var map = {
	"./CurrencyManagement": 1050,
	"./CurrencyManagement.js": 1050,
	"./TRM": 1051,
	"./TRM.js": 1051,
	"./TRM/filter": 174,
	"./TRM/filter.js": 174,
	"./TRM/table": 175,
	"./TRM/table.js": 175,
	"./accounting/accounts": 1052,
	"./accounting/accounts.js": 1052,
	"./accounting/accounts/filter": 176,
	"./accounting/accounts/filter.js": 176,
	"./accounting/accounts/table": 177,
	"./accounting/accounts/table.js": 177,
	"./accounting/area": 1053,
	"./accounting/area.js": 1053,
	"./accounting/area/filter": 1006,
	"./accounting/area/filter.js": 1006,
	"./accounting/area/table": 178,
	"./accounting/area/table.js": 178,
	"./accounting/area_copy": 1054,
	"./accounting/area_copy.js": 1054,
	"./accounting/closingDayReport": 1055,
	"./accounting/closingDayReport.js": 1055,
	"./accounting/closingDayReport/filter": 179,
	"./accounting/closingDayReport/filter.js": 179,
	"./accounting/closingDayReport/table": 180,
	"./accounting/closingDayReport/table.js": 180,
	"./accounting/concepts": 1056,
	"./accounting/concepts.js": 1056,
	"./accounting/concepts/filter": 181,
	"./accounting/concepts/filter.js": 181,
	"./accounting/concepts/table": 182,
	"./accounting/concepts/table.js": 182,
	"./accounting/costCenter": 1057,
	"./accounting/costCenter.js": 1057,
	"./accounting/costCenter/filter": 183,
	"./accounting/costCenter/filter.js": 183,
	"./accounting/costCenter/table": 184,
	"./accounting/costCenter/table.js": 184,
	"./accounting/employees": 1058,
	"./accounting/employees.js": 1058,
	"./accounting/employees/filter": 1007,
	"./accounting/employees/filter.js": 1007,
	"./accounting/employees/table": 185,
	"./accounting/employees/table.js": 185,
	"./accounting/expenses": 1059,
	"./accounting/expenses.js": 1059,
	"./accounting/expenses/filter": 186,
	"./accounting/expenses/filter.js": 186,
	"./accounting/expenses/table": 187,
	"./accounting/expenses/table.js": 187,
	"./accounting/incomes": 1060,
	"./accounting/incomes.js": 1060,
	"./accounting/incomes/filter": 188,
	"./accounting/incomes/filter.js": 188,
	"./accounting/incomes/table": 189,
	"./accounting/incomes/table.js": 189,
	"./accounting/position": 1061,
	"./accounting/position.js": 1061,
	"./accounting/position/filter": 1008,
	"./accounting/position/filter.js": 1008,
	"./accounting/position/table": 190,
	"./accounting/position/table.js": 190,
	"./accounting/productsThirdBetShop": 1062,
	"./accounting/productsThirdBetShop.js": 1062,
	"./accounting/productsThirdBetShop/filter": 1009,
	"./accounting/productsThirdBetShop/filter.js": 1009,
	"./accounting/productsThirdBetShop/table": 191,
	"./accounting/productsThirdBetShop/table.js": 191,
	"./accounting/productsThirdByBetShop": 1063,
	"./accounting/productsThirdByBetShop.js": 1063,
	"./accounting/productsThirdByBetShop/filter": 192,
	"./accounting/productsThirdByBetShop/filter.js": 192,
	"./accounting/productsThirdByBetShop/table": 193,
	"./accounting/productsThirdByBetShop/table.js": 193,
	"./accounting/productsThirdQuota": 1064,
	"./accounting/productsThirdQuota.js": 1064,
	"./accounting/productsThirdQuota/filter": 194,
	"./accounting/productsThirdQuota/filter.js": 194,
	"./accounting/productsThirdQuota/table": 195,
	"./accounting/productsThirdQuota/table.js": 195,
	"./accounting/providers": 1065,
	"./accounting/providers.js": 1065,
	"./accounting/providers/filter": 1010,
	"./accounting/providers/filter.js": 1010,
	"./accounting/providers/table": 196,
	"./accounting/providers/table.js": 196,
	"./accounting/providers/tableProductsThirdBetShop": 1066,
	"./accounting/providers/tableProductsThirdBetShop.js": 1066,
	"./accounting/providers_copy": 1067,
	"./accounting/providers_copy.js": 1067,
	"./accounting/squareDayReport": 1068,
	"./accounting/squareDayReport.js": 1068,
	"./accounting/squareDayReport/filter": 197,
	"./accounting/squareDayReport/filter.js": 197,
	"./accounting/squareDayReport/table": 198,
	"./accounting/squareDayReport/table.js": 198,
	"./accounting/squareDayReport2": 1069,
	"./accounting/squareDayReport2.js": 1069,
	"./accounting/squareDayReport2/filter": 199,
	"./accounting/squareDayReport2/filter.js": 199,
	"./accounting/squareDayReport2/table": 200,
	"./accounting/squareDayReport2/table.js": 200,
	"./accounting/typeCenterPosition": 1070,
	"./accounting/typeCenterPosition.js": 1070,
	"./accounting/typeDocument": 1071,
	"./accounting/typeDocument.js": 1071,
	"./accounting/typeDocument/filter": 202,
	"./accounting/typeDocument/filter.js": 202,
	"./accounting/typeDocument/table": 203,
	"./accounting/typeDocument/table.js": 203,
	"./accounting/types/filter": 1011,
	"./accounting/types/filter.js": 1011,
	"./accounting/types/table": 201,
	"./accounting/types/table.js": 201,
	"./activateRegistration": 1072,
	"./activateRegistration.js": 1072,
	"./activeProviders": 1073,
	"./activeProviders.js": 1073,
	"./addAdminUserManagement": 1074,
	"./addAdminUserManagement.js": 1074,
	"./addAgentListManagement": 1075,
	"./addAgentListManagement.js": 1075,
	"./addBetShopManagement": 1076,
	"./addBetShopManagement.js": 1076,
	"./adminUser": 1077,
	"./adminUser.js": 1077,
	"./adminUserManagement": 1078,
	"./adminUserManagement.js": 1078,
	"./affiliatesBetShop": 1079,
	"./affiliatesBetShop.js": 1079,
	"./agent/addInformationAgentList": 1080,
	"./agent/addInformationAgentList.js": 1080,
	"./agent/age": 1081,
	"./agent/age.js": 1081,
	"./agent/agent-list/detailsAgentList": 212,
	"./agent/agent-list/detailsAgentList.js": 212,
	"./agent/agent-list/filterAgentList": 213,
	"./agent/agent-list/filterAgentList.js": 213,
	"./agent/agent-list/recordAgentList": 214,
	"./agent/agent-list/recordAgentList.js": 214,
	"./agent/agent-list/recordTableAgentList": 1012,
	"./agent/agent-list/recordTableAgentList.js": 1012,
	"./agent/agent-list/tableAgentList": 215,
	"./agent/agent-list/tableAgentList.js": 215,
	"./agent/agent-retraction/PagoPremio": 216,
	"./agent/agent-retraction/PagoPremio.js": 216,
	"./agent/agent-retraction/search": 217,
	"./agent/agent-retraction/search.js": 217,
	"./agent/agent-retraction/transfers": 218,
	"./agent/agent-retraction/transfers.js": 218,
	"./agent/agent-retraction/transfers1": 219,
	"./agent/agent-retraction/transfers1.js": 219,
	"./agent/agent-transfers/PagoPremio": 220,
	"./agent/agent-transfers/PagoPremio.js": 220,
	"./agent/agent-transfers/search": 221,
	"./agent/agent-transfers/search.js": 221,
	"./agent/agent-transfers/transfers": 222,
	"./agent/agent-transfers/transfers.js": 222,
	"./agent/agent-transfers/transfers1": 223,
	"./agent/agent-transfers/transfers1.js": 223,
	"./agent/agent-tree/details": 1013,
	"./agent/agent-tree/details.js": 1013,
	"./agent/agent-tree/filter": 224,
	"./agent/agent-tree/filter.js": 224,
	"./agent/agent-tree/record": 130,
	"./agent/agent-tree/record.js": 130,
	"./agent/agent-tree/recordTableAgentList": 225,
	"./agent/agent-tree/recordTableAgentList.js": 225,
	"./agent/agent-tree/table": 226,
	"./agent/agent-tree/table.js": 226,
	"./agent/bonusReportAgentList": 1082,
	"./agent/bonusReportAgentList.js": 1082,
	"./agent/casinoGamesReportAgentList": 1083,
	"./agent/casinoGamesReportAgentList.js": 1083,
	"./agent/comissions": 1084,
	"./agent/comissions.js": 1084,
	"./agent/comissions/autoexclusionUsers": 1085,
	"./agent/comissions/autoexclusionUsers.js": 1085,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1086,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1086,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1087,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1087,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1088,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1088,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1089,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1089,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1090,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1090,
	"./agent/comissions/betsReport/detailsReport": 1091,
	"./agent/comissions/betsReport/detailsReport.js": 1091,
	"./agent/comissions/betsReport/filterReport": 1092,
	"./agent/comissions/betsReport/filterReport.js": 1092,
	"./agent/comissions/betsReport/recordReport": 1093,
	"./agent/comissions/betsReport/recordReport.js": 1093,
	"./agent/comissions/betsReport/recordTableReport": 1094,
	"./agent/comissions/betsReport/recordTableReport.js": 1094,
	"./agent/comissions/betsReport/recordTableTransReport": 1095,
	"./agent/comissions/betsReport/recordTableTransReport.js": 1095,
	"./agent/comissions/betsReport/recordTransReport": 1096,
	"./agent/comissions/betsReport/recordTransReport.js": 1096,
	"./agent/comissions/betsReport/tableReport": 1097,
	"./agent/comissions/betsReport/tableReport.js": 1097,
	"./agent/comissions/betsReportBetShop": 1098,
	"./agent/comissions/betsReportBetShop.js": 1098,
	"./agent/comissions/bonusReport/detailsBonusReport": 1099,
	"./agent/comissions/bonusReport/detailsBonusReport.js": 1099,
	"./agent/comissions/bonusReport/filterBonusReport": 1100,
	"./agent/comissions/bonusReport/filterBonusReport.js": 1100,
	"./agent/comissions/bonusReport/recordBonusReport": 1101,
	"./agent/comissions/bonusReport/recordBonusReport.js": 1101,
	"./agent/comissions/bonusReport/recordTableBonusReport": 1102,
	"./agent/comissions/bonusReport/recordTableBonusReport.js": 1102,
	"./agent/comissions/bonusReport/tableBonusReport": 1103,
	"./agent/comissions/bonusReport/tableBonusReport.js": 1103,
	"./agent/comissions/casinoReport/detailsCasinoReport": 1104,
	"./agent/comissions/casinoReport/detailsCasinoReport.js": 1104,
	"./agent/comissions/casinoReport/filterCasinoReport": 1105,
	"./agent/comissions/casinoReport/filterCasinoReport.js": 1105,
	"./agent/comissions/casinoReport/recordCasinoReport": 1106,
	"./agent/comissions/casinoReport/recordCasinoReport.js": 1106,
	"./agent/comissions/casinoReport/recordTableCasinoReport": 1107,
	"./agent/comissions/casinoReport/recordTableCasinoReport.js": 1107,
	"./agent/comissions/casinoReport/tableCasinoReport": 1108,
	"./agent/comissions/casinoReport/tableCasinoReport.js": 1108,
	"./agent/comissions/casinoReport2/detailsCasinoReport": 1109,
	"./agent/comissions/casinoReport2/detailsCasinoReport.js": 1109,
	"./agent/comissions/casinoReport2/filterCasinoReport": 1110,
	"./agent/comissions/casinoReport2/filterCasinoReport.js": 1110,
	"./agent/comissions/casinoReport2/recordCasinoReport": 1111,
	"./agent/comissions/casinoReport2/recordCasinoReport.js": 1111,
	"./agent/comissions/casinoReport2/recordTableCasinoReport": 1112,
	"./agent/comissions/casinoReport2/recordTableCasinoReport.js": 1112,
	"./agent/comissions/casinoReport2/tableCasinoReport": 1113,
	"./agent/comissions/casinoReport2/tableCasinoReport.js": 1113,
	"./agent/comissions/comissions": 1114,
	"./agent/comissions/comissions.js": 1114,
	"./agent/comissions/comissions/table": 235,
	"./agent/comissions/comissions/table.js": 235,
	"./agent/comissions/comissionsReportBetShop": 1115,
	"./agent/comissions/comissionsReportBetShop.js": 1115,
	"./agent/comissions/comissionsReportBetShopDetail": 1116,
	"./agent/comissions/comissionsReportBetShopDetail.js": 1116,
	"./agent/comissions/comissions_report/detailsDepositReports": 1117,
	"./agent/comissions/comissions_report/detailsDepositReports.js": 1117,
	"./agent/comissions/comissions_report/filter": 236,
	"./agent/comissions/comissions_report/filter.js": 236,
	"./agent/comissions/comissions_report/recordDepositReports": 1118,
	"./agent/comissions/comissions_report/recordDepositReports.js": 1118,
	"./agent/comissions/comissions_report/recordTableDepositReports": 1119,
	"./agent/comissions/comissions_report/recordTableDepositReports.js": 1119,
	"./agent/comissions/comissions_report/table": 237,
	"./agent/comissions/comissions_report/table.js": 237,
	"./agent/comissions/comissions_report_detail/detailsDepositReports": 1120,
	"./agent/comissions/comissions_report_detail/detailsDepositReports.js": 1120,
	"./agent/comissions/comissions_report_detail/filter": 238,
	"./agent/comissions/comissions_report_detail/filter.js": 238,
	"./agent/comissions/comissions_report_detail/recordDepositReports": 1121,
	"./agent/comissions/comissions_report_detail/recordDepositReports.js": 1121,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports": 1122,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports.js": 1122,
	"./agent/comissions/comissions_report_detail/table": 239,
	"./agent/comissions/comissions_report_detail/table.js": 239,
	"./agent/comissions/expenses": 1123,
	"./agent/comissions/expenses.js": 1123,
	"./agent/comissions/expenses/filter": 1124,
	"./agent/comissions/expenses/filter.js": 1124,
	"./agent/comissions/expenses/table": 1125,
	"./agent/comissions/expenses/table.js": 1125,
	"./agent/comissions/flujocaja/detailsFlujoCaja": 1126,
	"./agent/comissions/flujocaja/detailsFlujoCaja.js": 1126,
	"./agent/comissions/flujocaja/filterFlujoCaja": 1127,
	"./agent/comissions/flujocaja/filterFlujoCaja.js": 1127,
	"./agent/comissions/flujocaja/recordFlujoCaja": 1128,
	"./agent/comissions/flujocaja/recordFlujoCaja.js": 1128,
	"./agent/comissions/flujocaja/recordTableFlujoCaja": 1129,
	"./agent/comissions/flujocaja/recordTableFlujoCaja.js": 1129,
	"./agent/comissions/flujocaja/tableFlujoCaja": 1130,
	"./agent/comissions/flujocaja/tableFlujoCaja.js": 1130,
	"./agent/comissions/incomes": 1131,
	"./agent/comissions/incomes.js": 1131,
	"./agent/comissions/incomes/filter": 1132,
	"./agent/comissions/incomes/filter.js": 1132,
	"./agent/comissions/incomes/table": 1133,
	"./agent/comissions/incomes/table.js": 1133,
	"./agent/comissions/productsThird": 1134,
	"./agent/comissions/productsThird.js": 1134,
	"./agent/comissions/productsThird/filter": 1135,
	"./agent/comissions/productsThird/filter.js": 1135,
	"./agent/comissions/productsThird/table": 1136,
	"./agent/comissions/productsThird/table.js": 1136,
	"./agent/comissions/promotionalCodes": 1137,
	"./agent/comissions/promotionalCodes.js": 1137,
	"./agent/comissions/promotionalCodes/filter": 1138,
	"./agent/comissions/promotionalCodes/filter.js": 1138,
	"./agent/comissions/promotionalCodes/table": 1139,
	"./agent/comissions/promotionalCodes/table.js": 1139,
	"./agent/comissions/withdrawalRequests": 1140,
	"./agent/comissions/withdrawalRequests.js": 1140,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests": 242,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 242,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest": 240,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest.js": 240,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1141,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1141,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest": 243,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest.js": 243,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest": 241,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest.js": 241,
	"./agent/configuration/changePassword": 1142,
	"./agent/configuration/changePassword.js": 1142,
	"./agent/configuration/changePassword/changePasswordView": 59,
	"./agent/configuration/changePassword/changePasswordView.js": 59,
	"./agent/configuration/generateToken": 1143,
	"./agent/configuration/generateToken.js": 1143,
	"./agent/configuration/generateToken/filter": 60,
	"./agent/configuration/generateToken/filter.js": 60,
	"./agent/configuration/generateToken/table": 61,
	"./agent/configuration/generateToken/table.js": 61,
	"./agent/configuration/qrgoogle": 1144,
	"./agent/configuration/qrgoogle.js": 1144,
	"./agent/configuration/securityChanges": 1145,
	"./agent/configuration/securityChanges.js": 1145,
	"./agent/configuration/securityChanges/filter": 46,
	"./agent/configuration/securityChanges/filter.js": 46,
	"./agent/configuration/securityChanges/table": 37,
	"./agent/configuration/securityChanges/table.js": 37,
	"./agent/configurationAgentList": 1146,
	"./agent/configurationAgentList.js": 1146,
	"./agent/depositReportAgentList": 1147,
	"./agent/depositReportAgentList.js": 1147,
	"./agent/financescustomerAgentList": 1148,
	"./agent/financescustomerAgentList.js": 1148,
	"./agent/financial/comisiones": 1149,
	"./agent/financial/comisiones.js": 1149,
	"./agent/financial/comisiones/table": 246,
	"./agent/financial/comisiones/table.js": 246,
	"./agent/financial/informationFinancialAgentList": 1150,
	"./agent/financial/informationFinancialAgentList.js": 1150,
	"./agent/financial/withdrawalRequestsAgentList": 1151,
	"./agent/financial/withdrawalRequestsAgentList.js": 1151,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList": 131,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList.js": 131,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList": 247,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList.js": 247,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList": 1152,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList.js": 1152,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList": 132,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList.js": 132,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList": 248,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList.js": 248,
	"./agent/flujoCajaAgentList": 1153,
	"./agent/flujoCajaAgentList.js": 1153,
	"./agent/flujoCajaHijosAgentList": 1154,
	"./agent/flujoCajaHijosAgentList.js": 1154,
	"./agent/geo": 1155,
	"./agent/geo.js": 1155,
	"./agent/informationAgentList": 1156,
	"./agent/informationAgentList.js": 1156,
	"./agent/informeRed/details": 1157,
	"./agent/informeRed/details.js": 1157,
	"./agent/informeRed/filter": 255,
	"./agent/informeRed/filter.js": 255,
	"./agent/informeRed/record": 1158,
	"./agent/informeRed/record.js": 1158,
	"./agent/informeRed/recordTable": 1159,
	"./agent/informeRed/recordTable.js": 1159,
	"./agent/informeRed/table": 256,
	"./agent/informeRed/table.js": 256,
	"./agent/money": 1160,
	"./agent/money.js": 1160,
	"./agent/paymenthistory": 1161,
	"./agent/paymenthistory.js": 1161,
	"./agent/positions": 1162,
	"./agent/positions.js": 1162,
	"./agent/reports/autoexclusionUsers": 1163,
	"./agent/reports/autoexclusionUsers.js": 1163,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1164,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1164,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers": 1165,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1165,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers": 1166,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1166,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1167,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1167,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers": 1168,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1168,
	"./agent/reports/balanceTransactionReport": 1169,
	"./agent/reports/balanceTransactionReport.js": 1169,
	"./agent/reports/balanceTransactionReport/filter": 257,
	"./agent/reports/balanceTransactionReport/filter.js": 257,
	"./agent/reports/balanceTransactionReport/table": 258,
	"./agent/reports/balanceTransactionReport/table.js": 258,
	"./agent/reports/betsReport/detailsReport": 1170,
	"./agent/reports/betsReport/detailsReport.js": 1170,
	"./agent/reports/betsReport/filterReport": 259,
	"./agent/reports/betsReport/filterReport.js": 259,
	"./agent/reports/betsReport/recordReport": 133,
	"./agent/reports/betsReport/recordReport.js": 133,
	"./agent/reports/betsReport/recordTableReport": 1171,
	"./agent/reports/betsReport/recordTableReport.js": 1171,
	"./agent/reports/betsReport/recordTableTransReport": 1172,
	"./agent/reports/betsReport/recordTableTransReport.js": 1172,
	"./agent/reports/betsReport/recordTransReport": 134,
	"./agent/reports/betsReport/recordTransReport.js": 134,
	"./agent/reports/betsReport/tableReport": 260,
	"./agent/reports/betsReport/tableReport.js": 260,
	"./agent/reports/betsReportAgentList": 1173,
	"./agent/reports/betsReportAgentList.js": 1173,
	"./agent/reports/bonusReport/detailsBonusReport": 229,
	"./agent/reports/bonusReport/detailsBonusReport.js": 229,
	"./agent/reports/bonusReport/filterBonusReport": 227,
	"./agent/reports/bonusReport/filterBonusReport.js": 227,
	"./agent/reports/bonusReport/recordBonusReport": 230,
	"./agent/reports/bonusReport/recordBonusReport.js": 230,
	"./agent/reports/bonusReport/recordTableBonusReport": 1174,
	"./agent/reports/bonusReport/recordTableBonusReport.js": 1174,
	"./agent/reports/bonusReport/tableBonusReport": 228,
	"./agent/reports/bonusReport/tableBonusReport.js": 228,
	"./agent/reports/casinoReport/detailsCasinoReport": 233,
	"./agent/reports/casinoReport/detailsCasinoReport.js": 233,
	"./agent/reports/casinoReport/filterCasinoReport": 231,
	"./agent/reports/casinoReport/filterCasinoReport.js": 231,
	"./agent/reports/casinoReport/recordCasinoReport": 234,
	"./agent/reports/casinoReport/recordCasinoReport.js": 234,
	"./agent/reports/casinoReport/recordTableCasinoReport": 1175,
	"./agent/reports/casinoReport/recordTableCasinoReport.js": 1175,
	"./agent/reports/casinoReport/tableCasinoReport": 232,
	"./agent/reports/casinoReport/tableCasinoReport.js": 232,
	"./agent/reports/casinoReport2/detailsCasinoReport": 1176,
	"./agent/reports/casinoReport2/detailsCasinoReport.js": 1176,
	"./agent/reports/casinoReport2/filterCasinoReport": 1177,
	"./agent/reports/casinoReport2/filterCasinoReport.js": 1177,
	"./agent/reports/casinoReport2/recordCasinoReport": 1178,
	"./agent/reports/casinoReport2/recordCasinoReport.js": 1178,
	"./agent/reports/casinoReport2/recordTableCasinoReport": 1179,
	"./agent/reports/casinoReport2/recordTableCasinoReport.js": 1179,
	"./agent/reports/casinoReport2/tableCasinoReport": 1180,
	"./agent/reports/casinoReport2/tableCasinoReport.js": 1180,
	"./agent/reports/deposit_report/detailsDepositReports": 1181,
	"./agent/reports/deposit_report/detailsDepositReports.js": 1181,
	"./agent/reports/deposit_report/filterDepositReports": 244,
	"./agent/reports/deposit_report/filterDepositReports.js": 244,
	"./agent/reports/deposit_report/recordDepositReports": 1182,
	"./agent/reports/deposit_report/recordDepositReports.js": 1182,
	"./agent/reports/deposit_report/recordTableDepositReports": 1183,
	"./agent/reports/deposit_report/recordTableDepositReports.js": 1183,
	"./agent/reports/deposit_report/tableDepositReports": 245,
	"./agent/reports/deposit_report/tableDepositReports.js": 245,
	"./agent/reports/flujocaja/detailsFlujoCaja": 1184,
	"./agent/reports/flujocaja/detailsFlujoCaja.js": 1184,
	"./agent/reports/flujocaja/filterFlujoCaja": 249,
	"./agent/reports/flujocaja/filterFlujoCaja.js": 249,
	"./agent/reports/flujocaja/recordFlujoCaja": 1185,
	"./agent/reports/flujocaja/recordFlujoCaja.js": 1185,
	"./agent/reports/flujocaja/recordTableFlujoCaja": 1186,
	"./agent/reports/flujocaja/recordTableFlujoCaja.js": 1186,
	"./agent/reports/flujocaja/tableFlujoCaja": 250,
	"./agent/reports/flujocaja/tableFlujoCaja.js": 250,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos": 253,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos.js": 253,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos": 251,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos.js": 251,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos": 254,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos.js": 254,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos": 1187,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos.js": 1187,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos": 252,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos.js": 252,
	"./agent/reports/managementReport": 1188,
	"./agent/reports/managementReport.js": 1188,
	"./agent/reports/managementReport/filterReports": 261,
	"./agent/reports/managementReport/filterReports.js": 261,
	"./agent/reports/managementReport/tableReports": 262,
	"./agent/reports/managementReport/tableReports.js": 262,
	"./agent/reports/marketing/filterReports": 263,
	"./agent/reports/marketing/filterReports.js": 263,
	"./agent/reports/marketing/tableReports": 264,
	"./agent/reports/marketing/tableReports.js": 264,
	"./agent/reports/marketingReport": 1189,
	"./agent/reports/marketingReport.js": 1189,
	"./agent/reports/promotionalCodes": 1190,
	"./agent/reports/promotionalCodes.js": 1190,
	"./agent/reports/promotionalCodes/filter": 265,
	"./agent/reports/promotionalCodes/filter.js": 265,
	"./agent/reports/promotionalCodes/table": 266,
	"./agent/reports/promotionalCodes/table.js": 266,
	"./agent/reports/quotaRetractionReport/filter": 267,
	"./agent/reports/quotaRetractionReport/filter.js": 267,
	"./agent/reports/quotaRetractionReport/table": 268,
	"./agent/reports/quotaRetractionReport/table.js": 268,
	"./agent/reports/quotaRetractionReportAgent": 1191,
	"./agent/reports/quotaRetractionReportAgent.js": 1191,
	"./agent/reports/transfersReport/filter": 269,
	"./agent/reports/transfersReport/filter.js": 269,
	"./agent/reports/transfersReport/table": 270,
	"./agent/reports/transfersReport/table.js": 270,
	"./agent/reports/trasnfersReport": 1192,
	"./agent/reports/trasnfersReport.js": 1192,
	"./agent/reports/userAfilliatesReport": 1193,
	"./agent/reports/userAfilliatesReport.js": 1193,
	"./agent/reports/user_affiliates/detailsReports": 273,
	"./agent/reports/user_affiliates/detailsReports.js": 273,
	"./agent/reports/user_affiliates/filterReports": 271,
	"./agent/reports/user_affiliates/filterReports.js": 271,
	"./agent/reports/user_affiliates/recordReports": 274,
	"./agent/reports/user_affiliates/recordReports.js": 274,
	"./agent/reports/user_affiliates/recordTableReports": 1194,
	"./agent/reports/user_affiliates/recordTableReports.js": 1194,
	"./agent/reports/user_affiliates/tableReports": 272,
	"./agent/reports/user_affiliates/tableReports.js": 272,
	"./agent/reportscustomerAgentList": 1195,
	"./agent/reportscustomerAgentList.js": 1195,
	"./agent/requestsAgent": 1196,
	"./agent/requestsAgent.js": 1196,
	"./agent/requestsAgent/filter": 275,
	"./agent/requestsAgent/filter.js": 275,
	"./agent/requestsAgent/table": 276,
	"./agent/requestsAgent/table.js": 276,
	"./agent/requirementsAgent": 1197,
	"./agent/requirementsAgent.js": 1197,
	"./agent/requirementsAgent/details": 279,
	"./agent/requirementsAgent/details.js": 279,
	"./agent/requirementsAgent/detailsFilter": 281,
	"./agent/requirementsAgent/detailsFilter.js": 281,
	"./agent/requirementsAgent/detailsTable": 280,
	"./agent/requirementsAgent/detailsTable.js": 280,
	"./agent/requirementsAgent/filter": 277,
	"./agent/requirementsAgent/filter.js": 277,
	"./agent/requirementsAgent/table": 278,
	"./agent/requirementsAgent/table.js": 278,
	"./agent/statistics/age": 282,
	"./agent/statistics/age.js": 282,
	"./agent/statistics/marketing": 283,
	"./agent/statistics/marketing.js": 283,
	"./agent/statistics/marketingvsregistros": 284,
	"./agent/statistics/marketingvsregistros.js": 284,
	"./agent/statistics/money": 285,
	"./agent/statistics/money.js": 285,
	"./agent/statisticsAgentList": 1198,
	"./agent/statisticsAgentList.js": 1198,
	"./agent/tags": 1199,
	"./agent/tags.js": 1199,
	"./agentList": 1200,
	"./agentList.js": 1200,
	"./agentListManagement": 1201,
	"./agentListManagement.js": 1201,
	"./agentRetraction": 1202,
	"./agentRetraction.js": 1202,
	"./agentTransfers": 1203,
	"./agentTransfers.js": 1203,
	"./agentsInform": 1204,
	"./agentsInform.js": 1204,
	"./agentsTree": 1205,
	"./agentsTree.js": 1205,
	"./alltactions": 286,
	"./alltactions.js": 286,
	"./approvalLogs": 1206,
	"./approvalLogs.js": 1206,
	"./approvalLogs2": 1207,
	"./approvalLogs2.js": 1207,
	"./approvalLogsBetShop": 1208,
	"./approvalLogsBetShop.js": 1208,
	"./assignmentQuotaMade": 1209,
	"./assignmentQuotaMade.js": 1209,
	"./assignmentQuotaR": 1210,
	"./assignmentQuotaR.js": 1210,
	"./autoexclusionUsers": 1211,
	"./autoexclusionUsers.js": 1211,
	"./balanceAdjustments": 1212,
	"./balanceAdjustments.js": 1212,
	"./balanceHistory": 1213,
	"./balanceHistory.js": 1213,
	"./balanceHistory2": 1214,
	"./balanceHistory2.js": 1214,
	"./balanceHistoryAdminUser": 1215,
	"./balanceHistoryAdminUser.js": 1215,
	"./balanceHistoryBetShop": 1216,
	"./balanceHistoryBetShop.js": 1216,
	"./balanceHistoryBetShop2": 1217,
	"./balanceHistoryBetShop2.js": 1217,
	"./balanceHistoryForAgent": 1218,
	"./balanceHistoryForAgent.js": 1218,
	"./balanceHistoryForBetShop": 1219,
	"./balanceHistoryForBetShop.js": 1219,
	"./balanceHistoryMachine": 1220,
	"./balanceHistoryMachine.js": 1220,
	"./balanceUsers": 1221,
	"./balanceUsers.js": 1221,
	"./bankAccounts": 1222,
	"./bankAccounts.js": 1222,
	"./banks": 1223,
	"./banks.js": 1223,
	"./betShop": 1224,
	"./betShop.js": 1224,
	"./betShopCompetence": 1225,
	"./betShopCompetence.js": 1225,
	"./betShopManagement": 1226,
	"./betShopManagement.js": 1226,
	"./betShopManagement/addInformationBetShop": 1227,
	"./betShopManagement/addInformationBetShop.js": 1227,
	"./betShopManagement/age": 1228,
	"./betShopManagement/age.js": 1228,
	"./betShopManagement/betShop/detailsBetShop": 1014,
	"./betShopManagement/betShop/detailsBetShop.js": 1014,
	"./betShopManagement/betShop/filterBetShop": 327,
	"./betShopManagement/betShop/filterBetShop.js": 327,
	"./betShopManagement/betShop/recordBetShop": 329,
	"./betShopManagement/betShop/recordBetShop.js": 329,
	"./betShopManagement/betShop/recordTableBetShop": 89,
	"./betShopManagement/betShop/recordTableBetShop.js": 89,
	"./betShopManagement/betShop/tableBetShop": 328,
	"./betShopManagement/betShop/tableBetShop.js": 328,
	"./betShopManagement/betShopCompetence/detailsBetShop": 1229,
	"./betShopManagement/betShopCompetence/detailsBetShop.js": 1229,
	"./betShopManagement/betShopCompetence/filterBetShop": 330,
	"./betShopManagement/betShopCompetence/filterBetShop.js": 330,
	"./betShopManagement/betShopCompetence/recordBetShop": 1230,
	"./betShopManagement/betShopCompetence/recordBetShop.js": 1230,
	"./betShopManagement/betShopCompetence/recordTableBetShop": 1231,
	"./betShopManagement/betShopCompetence/recordTableBetShop.js": 1231,
	"./betShopManagement/betShopCompetence/tableBetShop": 331,
	"./betShopManagement/betShopCompetence/tableBetShop.js": 331,
	"./betShopManagement/bonusReportBetShop": 1232,
	"./betShopManagement/bonusReportBetShop.js": 1232,
	"./betShopManagement/cashier/betShopAdvertising": 336,
	"./betShopManagement/cashier/betShopAdvertising.js": 336,
	"./betShopManagement/cashier/betShopAdvertisingCashier": 338,
	"./betShopManagement/cashier/betShopAdvertisingCashier.js": 338,
	"./betShopManagement/cashier/betShopCashier": 1233,
	"./betShopManagement/cashier/betShopCashier.js": 1233,
	"./betShopManagement/cashier/betShopComissions": 1015,
	"./betShopManagement/cashier/betShopComissions.js": 1015,
	"./betShopManagement/cashier/filterCashier": 341,
	"./betShopManagement/cashier/filterCashier.js": 341,
	"./betShopManagement/cashier/tableAdvertising": 337,
	"./betShopManagement/cashier/tableAdvertising.js": 337,
	"./betShopManagement/cashier/tableAdvertisingCashier": 339,
	"./betShopManagement/cashier/tableAdvertisingCashier.js": 339,
	"./betShopManagement/cashier/tableCashier": 90,
	"./betShopManagement/cashier/tableCashier.js": 90,
	"./betShopManagement/cashier/tableComissions": 340,
	"./betShopManagement/cashier/tableComissions.js": 340,
	"./betShopManagement/casinoGamesReportBetShop": 1234,
	"./betShopManagement/casinoGamesReportBetShop.js": 1234,
	"./betShopManagement/comissions": 1235,
	"./betShopManagement/comissions.js": 1235,
	"./betShopManagement/comissions/autoexclusionUsers": 1236,
	"./betShopManagement/comissions/autoexclusionUsers.js": 1236,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1237,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1237,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1238,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1238,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1239,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1239,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1240,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1240,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1241,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1241,
	"./betShopManagement/comissions/betsReport/detailsReport": 1242,
	"./betShopManagement/comissions/betsReport/detailsReport.js": 1242,
	"./betShopManagement/comissions/betsReport/filterReport": 1243,
	"./betShopManagement/comissions/betsReport/filterReport.js": 1243,
	"./betShopManagement/comissions/betsReport/recordReport": 1244,
	"./betShopManagement/comissions/betsReport/recordReport.js": 1244,
	"./betShopManagement/comissions/betsReport/recordTableReport": 1245,
	"./betShopManagement/comissions/betsReport/recordTableReport.js": 1245,
	"./betShopManagement/comissions/betsReport/recordTableTransReport": 1246,
	"./betShopManagement/comissions/betsReport/recordTableTransReport.js": 1246,
	"./betShopManagement/comissions/betsReport/recordTransReport": 1247,
	"./betShopManagement/comissions/betsReport/recordTransReport.js": 1247,
	"./betShopManagement/comissions/betsReport/tableReport": 1248,
	"./betShopManagement/comissions/betsReport/tableReport.js": 1248,
	"./betShopManagement/comissions/betsReportBetShop": 1249,
	"./betShopManagement/comissions/betsReportBetShop.js": 1249,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport": 1250,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport.js": 1250,
	"./betShopManagement/comissions/bonusReport/filterBonusReport": 1251,
	"./betShopManagement/comissions/bonusReport/filterBonusReport.js": 1251,
	"./betShopManagement/comissions/bonusReport/recordBonusReport": 1252,
	"./betShopManagement/comissions/bonusReport/recordBonusReport.js": 1252,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport": 1253,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport.js": 1253,
	"./betShopManagement/comissions/bonusReport/tableBonusReport": 1254,
	"./betShopManagement/comissions/bonusReport/tableBonusReport.js": 1254,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport": 1255,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport.js": 1255,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport": 1256,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport.js": 1256,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport": 1257,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport.js": 1257,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport": 1258,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport.js": 1258,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport": 1259,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport.js": 1259,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport": 1260,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport.js": 1260,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport": 1261,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport.js": 1261,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport": 1262,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport.js": 1262,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport": 1263,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport.js": 1263,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport": 1264,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport.js": 1264,
	"./betShopManagement/comissions/comissions": 1265,
	"./betShopManagement/comissions/comissions.js": 1265,
	"./betShopManagement/comissions/comissions/table": 346,
	"./betShopManagement/comissions/comissions/table.js": 346,
	"./betShopManagement/comissions/comissionsReportBetShop": 1266,
	"./betShopManagement/comissions/comissionsReportBetShop.js": 1266,
	"./betShopManagement/comissions/comissionsReportBetShopDetail": 1267,
	"./betShopManagement/comissions/comissionsReportBetShopDetail.js": 1267,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports": 1268,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports.js": 1268,
	"./betShopManagement/comissions/comissions_report/filter": 347,
	"./betShopManagement/comissions/comissions_report/filter.js": 347,
	"./betShopManagement/comissions/comissions_report/recordDepositReports": 1269,
	"./betShopManagement/comissions/comissions_report/recordDepositReports.js": 1269,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports": 1270,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports.js": 1270,
	"./betShopManagement/comissions/comissions_report/table": 348,
	"./betShopManagement/comissions/comissions_report/table.js": 348,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports": 1271,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports.js": 1271,
	"./betShopManagement/comissions/comissions_report_detail/filter": 349,
	"./betShopManagement/comissions/comissions_report_detail/filter.js": 349,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports": 1272,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports.js": 1272,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports": 1273,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports.js": 1273,
	"./betShopManagement/comissions/comissions_report_detail/table": 350,
	"./betShopManagement/comissions/comissions_report_detail/table.js": 350,
	"./betShopManagement/comissions/expenses": 1274,
	"./betShopManagement/comissions/expenses.js": 1274,
	"./betShopManagement/comissions/expenses/filter": 1275,
	"./betShopManagement/comissions/expenses/filter.js": 1275,
	"./betShopManagement/comissions/expenses/table": 1276,
	"./betShopManagement/comissions/expenses/table.js": 1276,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja": 1277,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja.js": 1277,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja": 1278,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja.js": 1278,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja": 1279,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja.js": 1279,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja": 1280,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja.js": 1280,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja": 1281,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja.js": 1281,
	"./betShopManagement/comissions/incomes": 1282,
	"./betShopManagement/comissions/incomes.js": 1282,
	"./betShopManagement/comissions/incomes/filter": 1283,
	"./betShopManagement/comissions/incomes/filter.js": 1283,
	"./betShopManagement/comissions/incomes/table": 1284,
	"./betShopManagement/comissions/incomes/table.js": 1284,
	"./betShopManagement/comissions/productsThird": 1285,
	"./betShopManagement/comissions/productsThird.js": 1285,
	"./betShopManagement/comissions/productsThird/filter": 1286,
	"./betShopManagement/comissions/productsThird/filter.js": 1286,
	"./betShopManagement/comissions/productsThird/table": 1287,
	"./betShopManagement/comissions/productsThird/table.js": 1287,
	"./betShopManagement/comissions/promotionalCodes": 1288,
	"./betShopManagement/comissions/promotionalCodes.js": 1288,
	"./betShopManagement/comissions/promotionalCodes/filter": 1289,
	"./betShopManagement/comissions/promotionalCodes/filter.js": 1289,
	"./betShopManagement/comissions/promotionalCodes/table": 1290,
	"./betShopManagement/comissions/promotionalCodes/table.js": 1290,
	"./betShopManagement/comissions/withdrawalRequests": 1291,
	"./betShopManagement/comissions/withdrawalRequests.js": 1291,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests": 353,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 353,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest": 351,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest.js": 351,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1292,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1292,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest": 354,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest.js": 354,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest": 352,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest.js": 352,
	"./betShopManagement/configuration/changePassword": 1293,
	"./betShopManagement/configuration/changePassword.js": 1293,
	"./betShopManagement/configuration/changePassword/changePasswordView": 355,
	"./betShopManagement/configuration/changePassword/changePasswordView.js": 355,
	"./betShopManagement/configuration/configNtc": 1294,
	"./betShopManagement/configuration/configNtc.js": 1294,
	"./betShopManagement/configuration/configNtc/configNtcView": 356,
	"./betShopManagement/configuration/configNtc/configNtcView.js": 356,
	"./betShopManagement/configuration/generateToken": 1295,
	"./betShopManagement/configuration/generateToken.js": 1295,
	"./betShopManagement/configuration/generateToken/filter": 357,
	"./betShopManagement/configuration/generateToken/filter.js": 357,
	"./betShopManagement/configuration/generateToken/table": 358,
	"./betShopManagement/configuration/generateToken/table.js": 358,
	"./betShopManagement/configuration/qrgoogle": 1296,
	"./betShopManagement/configuration/qrgoogle.js": 1296,
	"./betShopManagement/configuration/securityChanges": 1297,
	"./betShopManagement/configuration/securityChanges.js": 1297,
	"./betShopManagement/configuration/securityChanges/filter": 1016,
	"./betShopManagement/configuration/securityChanges/filter.js": 1016,
	"./betShopManagement/configuration/securityChanges/table": 359,
	"./betShopManagement/configuration/securityChanges/table.js": 359,
	"./betShopManagement/configurationBetShop": 1298,
	"./betShopManagement/configurationBetShop.js": 1298,
	"./betShopManagement/depositReportBetShop": 1299,
	"./betShopManagement/depositReportBetShop.js": 1299,
	"./betShopManagement/financescustomerBetShop": 1300,
	"./betShopManagement/financescustomerBetShop.js": 1300,
	"./betShopManagement/financial/bankAccountsBetShop": 1301,
	"./betShopManagement/financial/bankAccountsBetShop.js": 1301,
	"./betShopManagement/financial/bankAccountsBetShop/details": 1302,
	"./betShopManagement/financial/bankAccountsBetShop/details.js": 1302,
	"./betShopManagement/financial/bankAccountsBetShop/filter": 362,
	"./betShopManagement/financial/bankAccountsBetShop/filter.js": 362,
	"./betShopManagement/financial/bankAccountsBetShop/record": 1303,
	"./betShopManagement/financial/bankAccountsBetShop/record.js": 1303,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable": 1304,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable.js": 1304,
	"./betShopManagement/financial/bankAccountsBetShop/table": 363,
	"./betShopManagement/financial/bankAccountsBetShop/table.js": 363,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup": 1305,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup.js": 1305,
	"./betShopManagement/financial/informationFinancialBetShop": 1306,
	"./betShopManagement/financial/informationFinancialBetShop.js": 1306,
	"./betShopManagement/financial/withdrawalRequestsBetShop": 1307,
	"./betShopManagement/financial/withdrawalRequestsBetShop.js": 1307,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop.js": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop": 364,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop.js": 364,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop": 366,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop.js": 366,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop.js": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop": 365,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop.js": 365,
	"./betShopManagement/flujoCajaBetShop": 1308,
	"./betShopManagement/flujoCajaBetShop.js": 1308,
	"./betShopManagement/geo": 1309,
	"./betShopManagement/geo.js": 1309,
	"./betShopManagement/informationBetShop": 1310,
	"./betShopManagement/informationBetShop.js": 1310,
	"./betShopManagement/money": 1311,
	"./betShopManagement/money.js": 1311,
	"./betShopManagement/paymenthistory": 1312,
	"./betShopManagement/paymenthistory.js": 1312,
	"./betShopManagement/positions": 1313,
	"./betShopManagement/positions.js": 1313,
	"./betShopManagement/reports/autoexclusionUsers": 1314,
	"./betShopManagement/reports/autoexclusionUsers.js": 1314,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1315,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1315,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers": 1316,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1316,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers": 1317,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1317,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1318,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1318,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers": 1319,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1319,
	"./betShopManagement/reports/balanceTransactionReport": 1320,
	"./betShopManagement/reports/balanceTransactionReport.js": 1320,
	"./betShopManagement/reports/balanceTransactionReport/filter": 369,
	"./betShopManagement/reports/balanceTransactionReport/filter.js": 369,
	"./betShopManagement/reports/balanceTransactionReport/table": 370,
	"./betShopManagement/reports/balanceTransactionReport/table.js": 370,
	"./betShopManagement/reports/betsReport/detailsReport": 1321,
	"./betShopManagement/reports/betsReport/detailsReport.js": 1321,
	"./betShopManagement/reports/betsReport/filterReport": 49,
	"./betShopManagement/reports/betsReport/filterReport.js": 49,
	"./betShopManagement/reports/betsReport/recordReport": 45,
	"./betShopManagement/reports/betsReport/recordReport.js": 45,
	"./betShopManagement/reports/betsReport/recordTableReport": 1322,
	"./betShopManagement/reports/betsReport/recordTableReport.js": 1322,
	"./betShopManagement/reports/betsReport/recordTableTransReport": 88,
	"./betShopManagement/reports/betsReport/recordTableTransReport.js": 88,
	"./betShopManagement/reports/betsReport/recordTransReport": 44,
	"./betShopManagement/reports/betsReport/recordTransReport.js": 44,
	"./betShopManagement/reports/betsReport/tableReport": 50,
	"./betShopManagement/reports/betsReport/tableReport.js": 50,
	"./betShopManagement/reports/betsReportBetShop": 1323,
	"./betShopManagement/reports/betsReportBetShop.js": 1323,
	"./betShopManagement/reports/bonusReport/detailsBonusReport": 334,
	"./betShopManagement/reports/bonusReport/detailsBonusReport.js": 334,
	"./betShopManagement/reports/bonusReport/filterBonusReport": 332,
	"./betShopManagement/reports/bonusReport/filterBonusReport.js": 332,
	"./betShopManagement/reports/bonusReport/recordBonusReport": 335,
	"./betShopManagement/reports/bonusReport/recordBonusReport.js": 335,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport": 1324,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport.js": 1324,
	"./betShopManagement/reports/bonusReport/tableBonusReport": 333,
	"./betShopManagement/reports/bonusReport/tableBonusReport.js": 333,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport": 344,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport.js": 344,
	"./betShopManagement/reports/casinoReport/filterCasinoReport": 342,
	"./betShopManagement/reports/casinoReport/filterCasinoReport.js": 342,
	"./betShopManagement/reports/casinoReport/recordCasinoReport": 345,
	"./betShopManagement/reports/casinoReport/recordCasinoReport.js": 345,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport": 1325,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport.js": 1325,
	"./betShopManagement/reports/casinoReport/tableCasinoReport": 343,
	"./betShopManagement/reports/casinoReport/tableCasinoReport.js": 343,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport": 1326,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport.js": 1326,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport": 1327,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport.js": 1327,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport": 1328,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport.js": 1328,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport": 1329,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport.js": 1329,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport": 1330,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport.js": 1330,
	"./betShopManagement/reports/deposit_report/detailsDepositReports": 1017,
	"./betShopManagement/reports/deposit_report/detailsDepositReports.js": 1017,
	"./betShopManagement/reports/deposit_report/filterDepositReports": 360,
	"./betShopManagement/reports/deposit_report/filterDepositReports.js": 360,
	"./betShopManagement/reports/deposit_report/recordDepositReports": 136,
	"./betShopManagement/reports/deposit_report/recordDepositReports.js": 136,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports": 1331,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports.js": 1331,
	"./betShopManagement/reports/deposit_report/tableDepositReports": 361,
	"./betShopManagement/reports/deposit_report/tableDepositReports.js": 361,
	"./betShopManagement/reports/expenses": 1332,
	"./betShopManagement/reports/expenses.js": 1332,
	"./betShopManagement/reports/expenses/filter": 51,
	"./betShopManagement/reports/expenses/filter.js": 51,
	"./betShopManagement/reports/expenses/table": 52,
	"./betShopManagement/reports/expenses/table.js": 52,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja": 1333,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja.js": 1333,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja": 367,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja.js": 367,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja": 1334,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja.js": 1334,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja": 1335,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja.js": 1335,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja": 368,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja.js": 368,
	"./betShopManagement/reports/historyMovement": 1336,
	"./betShopManagement/reports/historyMovement.js": 1336,
	"./betShopManagement/reports/historyMovement/filter": 371,
	"./betShopManagement/reports/historyMovement/filter.js": 371,
	"./betShopManagement/reports/historyMovement/table": 372,
	"./betShopManagement/reports/historyMovement/table.js": 372,
	"./betShopManagement/reports/incomes": 1337,
	"./betShopManagement/reports/incomes.js": 1337,
	"./betShopManagement/reports/incomes/filter": 53,
	"./betShopManagement/reports/incomes/filter.js": 53,
	"./betShopManagement/reports/incomes/table": 54,
	"./betShopManagement/reports/incomes/table.js": 54,
	"./betShopManagement/reports/productsThird": 1338,
	"./betShopManagement/reports/productsThird.js": 1338,
	"./betShopManagement/reports/productsThird/filter": 55,
	"./betShopManagement/reports/productsThird/filter.js": 55,
	"./betShopManagement/reports/productsThird/table": 56,
	"./betShopManagement/reports/productsThird/table.js": 56,
	"./betShopManagement/reports/promotionalCodes": 1339,
	"./betShopManagement/reports/promotionalCodes.js": 1339,
	"./betShopManagement/reports/promotionalCodes/filter": 57,
	"./betShopManagement/reports/promotionalCodes/filter.js": 57,
	"./betShopManagement/reports/promotionalCodes/table": 58,
	"./betShopManagement/reports/promotionalCodes/table.js": 58,
	"./betShopManagement/reports/userAffiliatesBetShop": 1340,
	"./betShopManagement/reports/userAffiliatesBetShop.js": 1340,
	"./betShopManagement/reports/userAffiliatesBetShop/filter": 373,
	"./betShopManagement/reports/userAffiliatesBetShop/filter.js": 373,
	"./betShopManagement/reports/userAffiliatesBetShop/table": 374,
	"./betShopManagement/reports/userAffiliatesBetShop/table.js": 374,
	"./betShopManagement/reportscustomerBetShop": 1341,
	"./betShopManagement/reportscustomerBetShop.js": 1341,
	"./betShopManagement/statisticsBetShop": 1342,
	"./betShopManagement/statisticsBetShop.js": 1342,
	"./betShopManagement/tags": 1343,
	"./betShopManagement/tags.js": 1343,
	"./betsHistory": 1344,
	"./betsHistory.js": 1344,
	"./betsHistory2": 1345,
	"./betsHistory2.js": 1345,
	"./betsReport": 1346,
	"./betsReport.js": 1346,
	"./betsReportBetShop": 1347,
	"./betsReportBetShop.js": 1347,
	"./betsReportSecond": 1348,
	"./betsReportSecond.js": 1348,
	"./betsSport": 1349,
	"./betsSport.js": 1349,
	"./betsSportLive": 1350,
	"./betsSportLive.js": 1350,
	"./betsVirtual": 1351,
	"./betsVirtual.js": 1351,
	"./betting": 1352,
	"./betting.js": 1352,
	"./bettingVirtual": 1353,
	"./bettingVirtual.js": 1353,
	"./blockchains": 1354,
	"./blockchains.js": 1354,
	"./bonusReport": 1355,
	"./bonusReport.js": 1355,
	"./bonusReport2": 1356,
	"./bonusReport2.js": 1356,
	"./bonusReports2": 1357,
	"./bonusReports2.js": 1357,
	"./cash/bankAccounts/filter": 322,
	"./cash/bankAccounts/filter.js": 322,
	"./cash/bankAccounts/table": 323,
	"./cash/bankAccounts/table.js": 323,
	"./cash/bets/betHistory": 91,
	"./cash/bets/betHistory.js": 91,
	"./cash/bets/betHistory2": 1358,
	"./cash/bets/betHistory2.js": 1358,
	"./cash/bets/sport": 70,
	"./cash/bets/sport.js": 70,
	"./cash/bets/sportLive": 379,
	"./cash/bets/sportLive.js": 379,
	"./cash/bets/sportVirtual": 380,
	"./cash/bets/sportVirtual.js": 380,
	"./cash/closeBox-edit/creditCards": 389,
	"./cash/closeBox-edit/creditCards.js": 389,
	"./cash/closeBox-edit/otherExpenses": 390,
	"./cash/closeBox-edit/otherExpenses.js": 390,
	"./cash/closeBox-edit/otherIncome": 391,
	"./cash/closeBox-edit/otherIncome.js": 391,
	"./cash/closeBox-edit/products": 392,
	"./cash/closeBox-edit/products.js": 392,
	"./cash/closeBox-edit/total": 393,
	"./cash/closeBox-edit/total.js": 393,
	"./cash/closeBox-old/otherExpenses": 1359,
	"./cash/closeBox-old/otherExpenses.js": 1359,
	"./cash/closeBox-old/otherIncome": 1360,
	"./cash/closeBox-old/otherIncome.js": 1360,
	"./cash/closeBox-old/products": 1361,
	"./cash/closeBox-old/products.js": 1361,
	"./cash/closeBox-old/total": 1362,
	"./cash/closeBox-old/total.js": 1362,
	"./cash/closeBox/creditCards": 394,
	"./cash/closeBox/creditCards.js": 394,
	"./cash/closeBox/otherExpenses": 95,
	"./cash/closeBox/otherExpenses.js": 95,
	"./cash/closeBox/otherIncome": 96,
	"./cash/closeBox/otherIncome.js": 96,
	"./cash/closeBox/products": 97,
	"./cash/closeBox/products.js": 97,
	"./cash/closeBox/total": 98,
	"./cash/closeBox/total.js": 98,
	"./cash/flujocaja/detailsFlujoCaja": 395,
	"./cash/flujocaja/detailsFlujoCaja.js": 395,
	"./cash/flujocaja/filterFlujoCaja": 396,
	"./cash/flujocaja/filterFlujoCaja.js": 396,
	"./cash/flujocaja/recordFlujoCaja": 397,
	"./cash/flujocaja/recordFlujoCaja.js": 397,
	"./cash/flujocaja/recordTableFlujoCaja": 14,
	"./cash/flujocaja/recordTableFlujoCaja.js": 14,
	"./cash/flujocaja/tableFlujoCaja": 398,
	"./cash/flujocaja/tableFlujoCaja.js": 398,
	"./cash/pagoNotaRetiro/PagoNotaRetiro": 399,
	"./cash/pagoNotaRetiro/PagoNotaRetiro.js": 399,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro": 400,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro.js": 400,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro": 1018,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro.js": 1018,
	"./cash/pagopremio/PagoPremio": 401,
	"./cash/pagopremio/PagoPremio.js": 401,
	"./cash/pagopremio/detailsPagoPremio": 402,
	"./cash/pagopremio/detailsPagoPremio.js": 402,
	"./cash/pagopremio/filterPagoPremio": 403,
	"./cash/pagopremio/filterPagoPremio.js": 403,
	"./cash/pagopremio/recordPagoPremio": 404,
	"./cash/pagopremio/recordPagoPremio.js": 404,
	"./cash/pagopremio/recordTablePagoPremio": 1363,
	"./cash/pagopremio/recordTablePagoPremio.js": 1363,
	"./cash/pagopremio/tablePagoPremio": 405,
	"./cash/pagopremio/tablePagoPremio.js": 405,
	"./cash/pagopremiovirtuales/PagoPremio": 406,
	"./cash/pagopremiovirtuales/PagoPremio.js": 406,
	"./cash/pagopremiovirtuales/detailsPagoPremio": 407,
	"./cash/pagopremiovirtuales/detailsPagoPremio.js": 407,
	"./cash/pagopremiovirtuales/filterPagoPremio": 408,
	"./cash/pagopremiovirtuales/filterPagoPremio.js": 408,
	"./cash/pagopremiovirtuales/recordPagoPremio": 409,
	"./cash/pagopremiovirtuales/recordPagoPremio.js": 409,
	"./cash/pagopremiovirtuales/recordTablePagoPremio": 1364,
	"./cash/pagopremiovirtuales/recordTablePagoPremio.js": 1364,
	"./cash/pagopremiovirtuales/tablePagoPremio": 410,
	"./cash/pagopremiovirtuales/tablePagoPremio.js": 410,
	"./cash/payPrizesLoyalty/PagoPremio": 411,
	"./cash/payPrizesLoyalty/PagoPremio.js": 411,
	"./cash/payPrizesLoyalty/filterPagoPremio": 412,
	"./cash/payPrizesLoyalty/filterPagoPremio.js": 412,
	"./cash/recargacredito/RecargaCredito": 413,
	"./cash/recargacredito/RecargaCredito.js": 413,
	"./cash/recargacredito/filterRecargaCredito": 414,
	"./cash/recargacredito/filterRecargaCredito.js": 414,
	"./cash/recargacreditoAgent/RecargaCredito": 415,
	"./cash/recargacreditoAgent/RecargaCredito.js": 415,
	"./cash/recargacreditoAgent/filterRecargaCredito": 416,
	"./cash/recargacreditoAgent/filterRecargaCredito.js": 416,
	"./cash/withdrawal/filter": 417,
	"./cash/withdrawal/filter.js": 417,
	"./cash/withdrawal/table": 418,
	"./cash/withdrawal/table.js": 418,
	"./cashiers": 1365,
	"./cashiers.js": 1365,
	"./casinoGamesReport": 1366,
	"./casinoGamesReport.js": 1366,
	"./casinoGamesReport2": 1368,
	"./casinoGamesReport2.js": 1368,
	"./categories": 1369,
	"./categories.js": 1369,
	"./categoriesProducts": 1370,
	"./categoriesProducts.js": 1370,
	"./closeBox": 1371,
	"./closeBox-old": 1372,
	"./closeBox-old.js": 1372,
	"./closeBox.js": 1371,
	"./closeBoxEdit": 1373,
	"./closeBoxEdit.js": 1373,
	"./comissionsReport": 1374,
	"./comissionsReport.js": 1374,
	"./comissionsReport2": 1375,
	"./comissionsReport2.js": 1375,
	"./commisionsPay": 1376,
	"./commisionsPay.js": 1376,
	"./competitors/competitors": 1377,
	"./competitors/competitors.js": 1377,
	"./competitors/filter": 435,
	"./competitors/filter.js": 435,
	"./competitors/table": 436,
	"./competitors/table.js": 436,
	"./consolidatedIncome": 1378,
	"./consolidatedIncome.js": 1378,
	"./consolidatedIncomeOwner": 1379,
	"./consolidatedIncomeOwner.js": 1379,
	"./consolidatedIncomeOwner2": 1380,
	"./consolidatedIncomeOwner2.js": 1380,
	"./contingency": 1381,
	"./contingency.js": 1381,
	"./countries": 1382,
	"./countries.js": 1382,
	"./coupons": 1383,
	"./coupons.js": 1383,
	"./couponsReport": 1384,
	"./couponsReport.js": 1384,
	"./cryptoBlockchain": 1385,
	"./cryptoBlockchain.js": 1385,
	"./cryptos": 1386,
	"./cryptos.js": 1386,
	"./customReport": 1387,
	"./customReport.js": 1387,
	"./customers": 1388,
	"./customers.js": 1388,
	"./customers/age": 34,
	"./customers/age.js": 34,
	"./customers/bonusReport": 1389,
	"./customers/bonusReport.js": 1389,
	"./customers/bonusReport2": 1390,
	"./customers/bonusReport2.js": 1390,
	"./customers/casinoGamesReport": 1391,
	"./customers/casinoGamesReport.js": 1391,
	"./customers/configuration": 1392,
	"./customers/configuration.js": 1392,
	"./customers/configuration/changePassword": 1393,
	"./customers/configuration/changePassword.js": 1393,
	"./customers/configuration/changePassword/changePasswordView": 103,
	"./customers/configuration/changePassword/changePasswordView.js": 103,
	"./customers/configuration/generateToken": 1394,
	"./customers/configuration/generateToken.js": 1394,
	"./customers/configuration/generateToken/filter": 104,
	"./customers/configuration/generateToken/filter.js": 104,
	"./customers/configuration/generateToken/table": 105,
	"./customers/configuration/generateToken/table.js": 105,
	"./customers/configuration/limitChanges": 1395,
	"./customers/configuration/limitChanges.js": 1395,
	"./customers/configuration/securityChanges": 1396,
	"./customers/configuration/securityChanges.js": 1396,
	"./customers/configuration/securityChanges/filter": 82,
	"./customers/configuration/securityChanges/filter.js": 82,
	"./customers/configuration/securityChanges/securityForm": 84,
	"./customers/configuration/securityChanges/securityForm.js": 84,
	"./customers/configuration/securityChanges/table": 48,
	"./customers/configuration/securityChanges/table.js": 48,
	"./customers/configuration/securityChanges2": 1397,
	"./customers/configuration/securityChanges2.js": 1397,
	"./customers/depositReport": 1398,
	"./customers/depositReport.js": 1398,
	"./customers/financescustomer": 1399,
	"./customers/financescustomer.js": 1399,
	"./customers/financial/bankAccounts": 1400,
	"./customers/financial/bankAccounts.js": 1400,
	"./customers/financial/bankAccounts/details": 1023,
	"./customers/financial/bankAccounts/details.js": 1023,
	"./customers/financial/bankAccounts/filter": 108,
	"./customers/financial/bankAccounts/filter.js": 108,
	"./customers/financial/bankAccounts/record": 458,
	"./customers/financial/bankAccounts/record.js": 458,
	"./customers/financial/bankAccounts/recordTable": 1401,
	"./customers/financial/bankAccounts/recordTable.js": 1401,
	"./customers/financial/bankAccounts/table": 109,
	"./customers/financial/bankAccounts/table.js": 109,
	"./customers/financial/bankAccounts/tablePopup": 1402,
	"./customers/financial/bankAccounts/tablePopup.js": 1402,
	"./customers/financial/informationFinancial": 1403,
	"./customers/financial/informationFinancial.js": 1403,
	"./customers/financial/withdrawalRequests": 1404,
	"./customers/financial/withdrawalRequests.js": 1404,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests": 77,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests.js": 77,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest": 110,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest.js": 110,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest": 63,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 63,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest": 78,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest.js": 78,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest": 111,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest.js": 111,
	"./customers/geo": 19,
	"./customers/geo.js": 19,
	"./customers/information": 1405,
	"./customers/information.js": 1405,
	"./customers/money": 33,
	"./customers/money.js": 33,
	"./customers/paymenthistory": 459,
	"./customers/paymenthistory.js": 459,
	"./customers/players/filter": 460,
	"./customers/players/filter.js": 460,
	"./customers/players/table": 461,
	"./customers/players/table.js": 461,
	"./customers/players2/filter": 462,
	"./customers/players2/filter.js": 462,
	"./customers/players2/table": 463,
	"./customers/players2/table.js": 463,
	"./customers/playersAggregator/filter": 464,
	"./customers/playersAggregator/filter.js": 464,
	"./customers/playersAggregator/table": 465,
	"./customers/playersAggregator/table.js": 465,
	"./customers/positions": 20,
	"./customers/positions.js": 20,
	"./customers/referralsReport": 1406,
	"./customers/referralsReport.js": 1406,
	"./customers/reports/autoexclusionUsers": 1407,
	"./customers/reports/autoexclusionUsers.js": 1407,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers": 27,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 27,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers": 21,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 21,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers": 67,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 67,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 87,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 87,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers": 22,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 22,
	"./customers/reports/balanceAdjustments": 1408,
	"./customers/reports/balanceAdjustments.js": 1408,
	"./customers/reports/balanceAdjustments/filter": 468,
	"./customers/reports/balanceAdjustments/filter.js": 468,
	"./customers/reports/balanceAdjustments/table": 469,
	"./customers/reports/balanceAdjustments/table.js": 469,
	"./customers/reports/balanceHistory": 1409,
	"./customers/reports/balanceHistory.js": 1409,
	"./customers/reports/balanceHistory/filter": 470,
	"./customers/reports/balanceHistory/filter.js": 470,
	"./customers/reports/balanceHistory/table": 471,
	"./customers/reports/balanceHistory/table.js": 471,
	"./customers/reports/betsReport": 1410,
	"./customers/reports/betsReport.js": 1410,
	"./customers/reports/betsReport/detailsReport": 1411,
	"./customers/reports/betsReport/detailsReport.js": 1411,
	"./customers/reports/betsReport/filterReport": 112,
	"./customers/reports/betsReport/filterReport.js": 112,
	"./customers/reports/betsReport/recordReport": 36,
	"./customers/reports/betsReport/recordReport.js": 36,
	"./customers/reports/betsReport/recordTableReport": 41,
	"./customers/reports/betsReport/recordTableReport.js": 41,
	"./customers/reports/betsReport/recordTableTransReport": 40,
	"./customers/reports/betsReport/recordTableTransReport.js": 40,
	"./customers/reports/betsReport/recordTransReport": 79,
	"./customers/reports/betsReport/recordTransReport.js": 79,
	"./customers/reports/betsReport/tableReport": 113,
	"./customers/reports/betsReport/tableReport.js": 113,
	"./customers/reports/bonusReport/detailsBonusReport": 72,
	"./customers/reports/bonusReport/detailsBonusReport.js": 72,
	"./customers/reports/bonusReport/filterBonusReport": 99,
	"./customers/reports/bonusReport/filterBonusReport.js": 99,
	"./customers/reports/bonusReport/recordBonusReport": 73,
	"./customers/reports/bonusReport/recordBonusReport.js": 73,
	"./customers/reports/bonusReport/recordTableBonusReport": 62,
	"./customers/reports/bonusReport/recordTableBonusReport.js": 62,
	"./customers/reports/bonusReport/tableBonusReport": 100,
	"./customers/reports/bonusReport/tableBonusReport.js": 100,
	"./customers/reports/bonusReport2/detailsBonusReport": 148,
	"./customers/reports/bonusReport2/detailsBonusReport.js": 148,
	"./customers/reports/bonusReport2/filterBonusReport": 456,
	"./customers/reports/bonusReport2/filterBonusReport.js": 456,
	"./customers/reports/bonusReport2/recordBonusReport": 149,
	"./customers/reports/bonusReport2/recordBonusReport.js": 149,
	"./customers/reports/bonusReport2/recordTableBonusReport": 1412,
	"./customers/reports/bonusReport2/recordTableBonusReport.js": 1412,
	"./customers/reports/bonusReport2/tableBonusReport": 457,
	"./customers/reports/bonusReport2/tableBonusReport.js": 457,
	"./customers/reports/casinoReport/detailsCasinoReport": 74,
	"./customers/reports/casinoReport/detailsCasinoReport.js": 74,
	"./customers/reports/casinoReport/filterCasinoReport": 101,
	"./customers/reports/casinoReport/filterCasinoReport.js": 101,
	"./customers/reports/casinoReport/recordCasinoReport": 75,
	"./customers/reports/casinoReport/recordCasinoReport.js": 75,
	"./customers/reports/casinoReport/recordTableCasinoReport": 39,
	"./customers/reports/casinoReport/recordTableCasinoReport.js": 39,
	"./customers/reports/casinoReport/tableCasinoReport": 102,
	"./customers/reports/casinoReport/tableCasinoReport.js": 102,
	"./customers/reports/casinoReport2/detailsCasinoReport": 1413,
	"./customers/reports/casinoReport2/detailsCasinoReport.js": 1413,
	"./customers/reports/casinoReport2/filterCasinoReport": 1414,
	"./customers/reports/casinoReport2/filterCasinoReport.js": 1414,
	"./customers/reports/casinoReport2/recordCasinoReport": 1415,
	"./customers/reports/casinoReport2/recordCasinoReport.js": 1415,
	"./customers/reports/casinoReport2/recordTableCasinoReport": 1416,
	"./customers/reports/casinoReport2/recordTableCasinoReport.js": 1416,
	"./customers/reports/casinoReport2/tableCasinoReport": 1417,
	"./customers/reports/casinoReport2/tableCasinoReport.js": 1417,
	"./customers/reports/deposit_report/detailsDepositReports": 170,
	"./customers/reports/deposit_report/detailsDepositReports.js": 170,
	"./customers/reports/deposit_report/filterDepositReports": 106,
	"./customers/reports/deposit_report/filterDepositReports.js": 106,
	"./customers/reports/deposit_report/recordDepositReports": 76,
	"./customers/reports/deposit_report/recordDepositReports.js": 76,
	"./customers/reports/deposit_report/recordTableDepositReports": 18,
	"./customers/reports/deposit_report/recordTableDepositReports.js": 18,
	"./customers/reports/deposit_report/tableDepositReports": 107,
	"./customers/reports/deposit_report/tableDepositReports.js": 107,
	"./customers/reports/historyMovement": 1418,
	"./customers/reports/historyMovement.js": 1418,
	"./customers/reports/historyMovement/filter": 472,
	"./customers/reports/historyMovement/filter.js": 472,
	"./customers/reports/historyMovement/table": 473,
	"./customers/reports/historyMovement/table.js": 473,
	"./customers/reports/historyPoints": 1419,
	"./customers/reports/historyPoints.js": 1419,
	"./customers/reports/historyPoints/filter": 474,
	"./customers/reports/historyPoints/filter.js": 474,
	"./customers/reports/historyPoints/table": 475,
	"./customers/reports/historyPoints/table.js": 475,
	"./customers/reports/logsUser": 1420,
	"./customers/reports/logsUser.js": 1420,
	"./customers/reports/logsUser/filter": 476,
	"./customers/reports/logsUser/filter.js": 476,
	"./customers/reports/logsUser/table": 477,
	"./customers/reports/logsUser/table.js": 477,
	"./customers/reports/loyaltyLevelChangeHistory": 1024,
	"./customers/reports/loyaltyLevelChangeHistory.js": 1024,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 478,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 478,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 479,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 479,
	"./customers/reports/notesUser": 1421,
	"./customers/reports/notesUser.js": 1421,
	"./customers/reports/notesUser/filter": 480,
	"./customers/reports/notesUser/filter.js": 480,
	"./customers/reports/notesUser/table": 481,
	"./customers/reports/notesUser/table.js": 481,
	"./customers/reports/playerPrizesLoyalty": 1422,
	"./customers/reports/playerPrizesLoyalty.js": 1422,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty": 482,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty.js": 482,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty": 483,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty.js": 483,
	"./customers/reports/playerRoulette": 1423,
	"./customers/reports/playerRoulette.js": 1423,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport": 484,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport.js": 484,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport": 485,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport.js": 485,
	"./customers/reports/qualifyingPointsRecord": 1424,
	"./customers/reports/qualifyingPointsRecord.js": 1424,
	"./customers/reports/qualifyingPointsRecordReport/filter": 486,
	"./customers/reports/qualifyingPointsRecordReport/filter.js": 486,
	"./customers/reports/qualifyingPointsRecordReport/table": 487,
	"./customers/reports/qualifyingPointsRecordReport/table.js": 487,
	"./customers/reports/referralsReport/filterReferralsReports": 466,
	"./customers/reports/referralsReport/filterReferralsReports.js": 466,
	"./customers/reports/referralsReport/recordReferralsReports": 1425,
	"./customers/reports/referralsReport/recordReferralsReports.js": 1425,
	"./customers/reports/referralsReport/recordTableReferralsReports": 1426,
	"./customers/reports/referralsReport/recordTableReferralsReports.js": 1426,
	"./customers/reports/referralsReport/tableReferralsReports": 467,
	"./customers/reports/referralsReport/tableReferralsReports.js": 467,
	"./customers/reports/registeredDocument": 1427,
	"./customers/reports/registeredDocument.js": 1427,
	"./customers/reports/registeredDocuments/filter": 488,
	"./customers/reports/registeredDocuments/filter.js": 488,
	"./customers/reports/registeredDocuments/table": 489,
	"./customers/reports/registeredDocuments/table.js": 489,
	"./customers/reports/sessionsReport": 1428,
	"./customers/reports/sessionsReport.js": 1428,
	"./customers/reports/sessionsReport/detailsSessionsReport": 492,
	"./customers/reports/sessionsReport/detailsSessionsReport.js": 492,
	"./customers/reports/sessionsReport/filterSessionsReport": 490,
	"./customers/reports/sessionsReport/filterSessionsReport.js": 490,
	"./customers/reports/sessionsReport/recordSessionsReport": 1025,
	"./customers/reports/sessionsReport/recordSessionsReport.js": 1025,
	"./customers/reports/sessionsReport/recordTableSessionsReport": 1026,
	"./customers/reports/sessionsReport/recordTableSessionsReport.js": 1026,
	"./customers/reports/sessionsReport/tableSessionsReport": 491,
	"./customers/reports/sessionsReport/tableSessionsReport.js": 491,
	"./customers/reports/sessionsReport2": 1429,
	"./customers/reports/sessionsReport2.js": 1429,
	"./customers/reports/sessionsReport2/filter": 493,
	"./customers/reports/sessionsReport2/filter.js": 493,
	"./customers/reports/sessionsReport2/table": 494,
	"./customers/reports/sessionsReport2/table.js": 494,
	"./customers/reports/walletsReport": 1430,
	"./customers/reports/walletsReport.js": 1430,
	"./customers/reports/walletsReport/filter": 495,
	"./customers/reports/walletsReport/filter.js": 495,
	"./customers/reports/walletsReport/table": 496,
	"./customers/reports/walletsReport/table.js": 496,
	"./customers/reportscustomer": 1431,
	"./customers/reportscustomer.js": 1431,
	"./customers/statistics": 1432,
	"./customers/statistics.js": 1432,
	"./customers/tags": 35,
	"./customers/tags.js": 35,
	"./customersAggregator": 1433,
	"./customersAggregator.js": 1433,
	"./customersAggregator/age": 1434,
	"./customersAggregator/age.js": 1434,
	"./customersAggregator/bonusReport": 1435,
	"./customersAggregator/bonusReport.js": 1435,
	"./customersAggregator/casinoGamesReport": 1436,
	"./customersAggregator/casinoGamesReport.js": 1436,
	"./customersAggregator/configuration": 1437,
	"./customersAggregator/configuration.js": 1437,
	"./customersAggregator/configuration/changePassword": 1438,
	"./customersAggregator/configuration/changePassword.js": 1438,
	"./customersAggregator/configuration/changePassword/changePasswordView": 1439,
	"./customersAggregator/configuration/changePassword/changePasswordView.js": 1439,
	"./customersAggregator/configuration/generateToken": 1440,
	"./customersAggregator/configuration/generateToken.js": 1440,
	"./customersAggregator/configuration/generateToken/filter": 1441,
	"./customersAggregator/configuration/generateToken/filter.js": 1441,
	"./customersAggregator/configuration/generateToken/table": 1442,
	"./customersAggregator/configuration/generateToken/table.js": 1442,
	"./customersAggregator/configuration/securityChanges": 1443,
	"./customersAggregator/configuration/securityChanges.js": 1443,
	"./customersAggregator/configuration/securityChanges/filter": 1444,
	"./customersAggregator/configuration/securityChanges/filter.js": 1444,
	"./customersAggregator/configuration/securityChanges/table": 1445,
	"./customersAggregator/configuration/securityChanges/table.js": 1445,
	"./customersAggregator/depositReport": 1446,
	"./customersAggregator/depositReport.js": 1446,
	"./customersAggregator/financescustomer": 1447,
	"./customersAggregator/financescustomer.js": 1447,
	"./customersAggregator/financial/bankAccounts": 1448,
	"./customersAggregator/financial/bankAccounts.js": 1448,
	"./customersAggregator/financial/bankAccounts/details": 1449,
	"./customersAggregator/financial/bankAccounts/details.js": 1449,
	"./customersAggregator/financial/bankAccounts/filter": 1450,
	"./customersAggregator/financial/bankAccounts/filter.js": 1450,
	"./customersAggregator/financial/bankAccounts/record": 1451,
	"./customersAggregator/financial/bankAccounts/record.js": 1451,
	"./customersAggregator/financial/bankAccounts/recordTable": 1452,
	"./customersAggregator/financial/bankAccounts/recordTable.js": 1452,
	"./customersAggregator/financial/bankAccounts/table": 1453,
	"./customersAggregator/financial/bankAccounts/table.js": 1453,
	"./customersAggregator/financial/bankAccounts/tablePopup": 1454,
	"./customersAggregator/financial/bankAccounts/tablePopup.js": 1454,
	"./customersAggregator/financial/informationFinancial": 1455,
	"./customersAggregator/financial/informationFinancial.js": 1455,
	"./customersAggregator/financial/withdrawalRequests": 1456,
	"./customersAggregator/financial/withdrawalRequests.js": 1456,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests": 1457,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests.js": 1457,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest": 1458,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest.js": 1458,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest": 1459,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 1459,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest": 1460,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest.js": 1460,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest": 1461,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest.js": 1461,
	"./customersAggregator/geo": 1462,
	"./customersAggregator/geo.js": 1462,
	"./customersAggregator/information": 1463,
	"./customersAggregator/information.js": 1463,
	"./customersAggregator/money": 1464,
	"./customersAggregator/money.js": 1464,
	"./customersAggregator/paymenthistory": 1465,
	"./customersAggregator/paymenthistory.js": 1465,
	"./customersAggregator/players/filter": 1466,
	"./customersAggregator/players/filter.js": 1466,
	"./customersAggregator/players/table": 1467,
	"./customersAggregator/players/table.js": 1467,
	"./customersAggregator/playersAggregator/filter": 1468,
	"./customersAggregator/playersAggregator/filter.js": 1468,
	"./customersAggregator/playersAggregator/table": 1469,
	"./customersAggregator/playersAggregator/table.js": 1469,
	"./customersAggregator/positions": 1470,
	"./customersAggregator/positions.js": 1470,
	"./customersAggregator/reports/autoexclusionUsers": 1471,
	"./customersAggregator/reports/autoexclusionUsers.js": 1471,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1472,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1472,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers": 1473,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1473,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers": 1474,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1474,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1475,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1475,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers": 1476,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1476,
	"./customersAggregator/reports/betsReport": 1477,
	"./customersAggregator/reports/betsReport.js": 1477,
	"./customersAggregator/reports/betsReport/detailsReport": 1478,
	"./customersAggregator/reports/betsReport/detailsReport.js": 1478,
	"./customersAggregator/reports/betsReport/filterReport": 1479,
	"./customersAggregator/reports/betsReport/filterReport.js": 1479,
	"./customersAggregator/reports/betsReport/recordReport": 1480,
	"./customersAggregator/reports/betsReport/recordReport.js": 1480,
	"./customersAggregator/reports/betsReport/recordTableReport": 1481,
	"./customersAggregator/reports/betsReport/recordTableReport.js": 1481,
	"./customersAggregator/reports/betsReport/recordTableTransReport": 1482,
	"./customersAggregator/reports/betsReport/recordTableTransReport.js": 1482,
	"./customersAggregator/reports/betsReport/recordTransReport": 1483,
	"./customersAggregator/reports/betsReport/recordTransReport.js": 1483,
	"./customersAggregator/reports/betsReport/tableReport": 1484,
	"./customersAggregator/reports/betsReport/tableReport.js": 1484,
	"./customersAggregator/reports/bonusReport/detailsBonusReport": 1485,
	"./customersAggregator/reports/bonusReport/detailsBonusReport.js": 1485,
	"./customersAggregator/reports/bonusReport/filterBonusReport": 1486,
	"./customersAggregator/reports/bonusReport/filterBonusReport.js": 1486,
	"./customersAggregator/reports/bonusReport/recordBonusReport": 1487,
	"./customersAggregator/reports/bonusReport/recordBonusReport.js": 1487,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport": 1488,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport.js": 1488,
	"./customersAggregator/reports/bonusReport/tableBonusReport": 1489,
	"./customersAggregator/reports/bonusReport/tableBonusReport.js": 1489,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport": 1490,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport.js": 1490,
	"./customersAggregator/reports/casinoReport/filterCasinoReport": 1491,
	"./customersAggregator/reports/casinoReport/filterCasinoReport.js": 1491,
	"./customersAggregator/reports/casinoReport/recordCasinoReport": 1492,
	"./customersAggregator/reports/casinoReport/recordCasinoReport.js": 1492,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport": 1493,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport.js": 1493,
	"./customersAggregator/reports/casinoReport/tableCasinoReport": 1494,
	"./customersAggregator/reports/casinoReport/tableCasinoReport.js": 1494,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport": 1495,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport.js": 1495,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport": 1496,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport.js": 1496,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport": 1497,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport.js": 1497,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport": 1498,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport.js": 1498,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport": 1499,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport.js": 1499,
	"./customersAggregator/reports/deposit_report/detailsDepositReports": 1500,
	"./customersAggregator/reports/deposit_report/detailsDepositReports.js": 1500,
	"./customersAggregator/reports/deposit_report/filterDepositReports": 1501,
	"./customersAggregator/reports/deposit_report/filterDepositReports.js": 1501,
	"./customersAggregator/reports/deposit_report/recordDepositReports": 1502,
	"./customersAggregator/reports/deposit_report/recordDepositReports.js": 1502,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports": 1503,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports.js": 1503,
	"./customersAggregator/reports/deposit_report/tableDepositReports": 1504,
	"./customersAggregator/reports/deposit_report/tableDepositReports.js": 1504,
	"./customersAggregator/reportscustomer": 1505,
	"./customersAggregator/reportscustomer.js": 1505,
	"./customersAggregator/statistics": 1506,
	"./customersAggregator/statistics.js": 1506,
	"./customersAggregator/tags": 1507,
	"./customersAggregator/tags.js": 1507,
	"./dashboard": 1508,
	"./dashboard.js": 1508,
	"./dashboard/dataview": 86,
	"./dashboard/dataview.js": 86,
	"./dashboard/jugadoresActivos": 83,
	"./dashboard/jugadoresActivos.js": 83,
	"./dashboard/jugadoresNuevos": 128,
	"./dashboard/jugadoresNuevos.js": 128,
	"./dates": 497,
	"./dates.js": 497,
	"./demos": 1509,
	"./demos.js": 1509,
	"./depositReport": 1510,
	"./depositReport.js": 1510,
	"./depositReport2": 1511,
	"./depositReport2.js": 1511,
	"./depositReport3": 1512,
	"./depositReport3.js": 1512,
	"./depositReportBetShop": 1513,
	"./depositReportBetShop.js": 1513,
	"./depositReportFranchise": 1514,
	"./depositReportFranchise.js": 1514,
	"./depositRequests": 1515,
	"./depositRequests.js": 1515,
	"./eliminateNoteWithdraw": 1516,
	"./eliminateNoteWithdraw.js": 1516,
	"./emailsReport": 1517,
	"./emailsReport.js": 1517,
	"./financial/depositRequests/filter": 508,
	"./financial/depositRequests/filter.js": 508,
	"./financial/depositRequests/record": 153,
	"./financial/depositRequests/record.js": 153,
	"./financial/depositRequests/recordTable": 510,
	"./financial/depositRequests/recordTable.js": 510,
	"./financial/depositRequests/table": 509,
	"./financial/depositRequests/table.js": 509,
	"./financial/withdrawalRequests": 1518,
	"./financial/withdrawalRequests.js": 1518,
	"./financial/withdrawalRequests/detailsWithdrawalRequests": 80,
	"./financial/withdrawalRequests/detailsWithdrawalRequests.js": 80,
	"./financial/withdrawalRequests/filterWithdrawalRequest": 114,
	"./financial/withdrawalRequests/filterWithdrawalRequest.js": 114,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest": 15,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest.js": 15,
	"./financial/withdrawalRequests/recordWithdrawalRequest": 81,
	"./financial/withdrawalRequests/recordWithdrawalRequest.js": 81,
	"./financial/withdrawalRequests/tableWithdrawalRequest": 115,
	"./financial/withdrawalRequests/tableWithdrawalRequest.js": 115,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests": 156,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 156,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest": 517,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 517,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1519,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1519,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest": 157,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 157,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest": 518,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 518,
	"./flujoCaja": 1520,
	"./flujoCaja.js": 1520,
	"./franchisee": 1521,
	"./franchisee.js": 1521,
	"./franchises": 1522,
	"./franchises.js": 1522,
	"./futureEvents": 1523,
	"./futureEvents.js": 1523,
	"./gamePerformanceReport": 1524,
	"./gamePerformanceReport.js": 1524,
	"./getReportStructureGames": 1525,
	"./getReportStructureGames.js": 1525,
	"./goldenRace": 1526,
	"./goldenRace.js": 1526,
	"./historicalCashFlow": 1527,
	"./historicalCashFlow.js": 1527,
	"./historyMovement": 1528,
	"./historyMovement.js": 1528,
	"./historyMovement/filter": 1529,
	"./historyMovement/filter.js": 1529,
	"./historyMovement/table": 1530,
	"./historyMovement/table.js": 1530,
	"./historyMovementBetShop": 1531,
	"./historyMovementBetShop.js": 1531,
	"./historyPoints": 1532,
	"./historyPoints.js": 1532,
	"./information/details": 24,
	"./information/details.js": 24,
	"./information/filter": 42,
	"./information/filter.js": 42,
	"./information/record": 25,
	"./information/record.js": 25,
	"./information/recordTable": 1533,
	"./information/recordTable.js": 1533,
	"./information/table": 43,
	"./information/table.js": 43,
	"./informationCasino": 1534,
	"./informationCasino.js": 1534,
	"./informationHipica": 1535,
	"./informationHipica.js": 1535,
	"./informationLiveCasino": 1536,
	"./informationLiveCasino.js": 1536,
	"./informationVirtual": 1537,
	"./informationVirtual.js": 1537,
	"./informeCasino": 1538,
	"./informeCasino.js": 1538,
	"./informeGerencial": 1539,
	"./informeGerencial.js": 1539,
	"./informeGerencial2": 1540,
	"./informeGerencial2.js": 1540,
	"./informeGerencialAgentes2": 1541,
	"./informeGerencialAgentes2.js": 1541,
	"./informeGerencialUsuarios2": 1542,
	"./informeGerencialUsuarios2.js": 1542,
	"./jackpotInternationalReport2": 1543,
	"./jackpotInternationalReport2.js": 1543,
	"./jackpotPaymentReports": 1544,
	"./jackpotPaymentReports.js": 1544,
	"./jackpotPaymentReports2": 1545,
	"./jackpotPaymentReports2.js": 1545,
	"./jackpotPrizeReport": 1546,
	"./jackpotPrizeReport.js": 1546,
	"./jackpotPrizeReportSportBet": 1547,
	"./jackpotPrizeReportSportBet.js": 1547,
	"./jackpotWinnersReport": 1548,
	"./jackpotWinnersReport.js": 1548,
	"./landingReport": 1549,
	"./landingReport.js": 1549,
	"./landingReport2": 1550,
	"./landingReport2.js": 1550,
	"./leagues/AddLeague": 1551,
	"./leagues/AddLeague.js": 1551,
	"./leagues/addLeagueManagement": 1552,
	"./leagues/addLeagueManagement.js": 1552,
	"./leagues/configuration": 1553,
	"./leagues/configuration.js": 1553,
	"./leagues/configuration/changePassword": 1554,
	"./leagues/configuration/changePassword.js": 1554,
	"./leagues/configuration/changePassword/changePasswordView": 1555,
	"./leagues/configuration/changePassword/changePasswordView.js": 1555,
	"./leagues/configuration/generateToken": 1556,
	"./leagues/configuration/generateToken.js": 1556,
	"./leagues/configuration/generateToken/filter": 1557,
	"./leagues/configuration/generateToken/filter.js": 1557,
	"./leagues/configuration/generateToken/table": 1558,
	"./leagues/configuration/generateToken/table.js": 1558,
	"./leagues/configuration/qrgoogle": 1559,
	"./leagues/configuration/qrgoogle.js": 1559,
	"./leagues/configuration/securityChanges": 1560,
	"./leagues/configuration/securityChanges.js": 1560,
	"./leagues/configuration/securityChanges/filter": 1561,
	"./leagues/configuration/securityChanges/filter.js": 1561,
	"./leagues/configuration/securityChanges/table": 1562,
	"./leagues/configuration/securityChanges/table.js": 1562,
	"./leagues/information": 1563,
	"./leagues/information.js": 1563,
	"./leagues/leagues-list/filter": 570,
	"./leagues/leagues-list/filter.js": 570,
	"./leagues/leagues-list/table": 571,
	"./leagues/leagues-list/table.js": 571,
	"./leagues/leaguesList": 1564,
	"./leagues/leaguesList.js": 1564,
	"./leagues/leaguesManagement": 1565,
	"./leagues/leaguesManagement.js": 1565,
	"./leagues/reports": 1566,
	"./leagues/reports.js": 1566,
	"./leagues/reports/betsReport": 1567,
	"./leagues/reports/betsReport.js": 1567,
	"./leagues/reports/betsReport/detailsReport": 1568,
	"./leagues/reports/betsReport/detailsReport.js": 1568,
	"./leagues/reports/betsReport/filterReport": 573,
	"./leagues/reports/betsReport/filterReport.js": 573,
	"./leagues/reports/betsReport/recordReport": 1569,
	"./leagues/reports/betsReport/recordReport.js": 1569,
	"./leagues/reports/betsReport/recordTableReport": 1570,
	"./leagues/reports/betsReport/recordTableReport.js": 1570,
	"./leagues/reports/betsReport/recordTableTransReport": 1571,
	"./leagues/reports/betsReport/recordTableTransReport.js": 1571,
	"./leagues/reports/betsReport/recordTransReport": 575,
	"./leagues/reports/betsReport/recordTransReport.js": 575,
	"./leagues/reports/betsReport/tableReport": 574,
	"./leagues/reports/betsReport/tableReport.js": 574,
	"./leagues/reports/casinoGamesReport": 1572,
	"./leagues/reports/casinoGamesReport.js": 1572,
	"./leagues/reports/casinoReport/detailsCasinoReport": 578,
	"./leagues/reports/casinoReport/detailsCasinoReport.js": 578,
	"./leagues/reports/casinoReport/filterCasinoReport": 576,
	"./leagues/reports/casinoReport/filterCasinoReport.js": 576,
	"./leagues/reports/casinoReport/recordCasinoReport": 579,
	"./leagues/reports/casinoReport/recordCasinoReport.js": 579,
	"./leagues/reports/casinoReport/recordTableCasinoReport": 1573,
	"./leagues/reports/casinoReport/recordTableCasinoReport.js": 1573,
	"./leagues/reports/casinoReport/tableCasinoReport": 577,
	"./leagues/reports/casinoReport/tableCasinoReport.js": 577,
	"./leagues/reports/userAfilliatesReport": 1574,
	"./leagues/reports/userAfilliatesReport.js": 1574,
	"./leagues/reports/user_affiliates/detailsReports": 1575,
	"./leagues/reports/user_affiliates/detailsReports.js": 1575,
	"./leagues/reports/user_affiliates/filterReports": 580,
	"./leagues/reports/user_affiliates/filterReports.js": 580,
	"./leagues/reports/user_affiliates/recordReports": 1576,
	"./leagues/reports/user_affiliates/recordReports.js": 1576,
	"./leagues/reports/user_affiliates/recordTableReports": 1577,
	"./leagues/reports/user_affiliates/recordTableReports.js": 1577,
	"./leagues/reports/user_affiliates/tableReports": 581,
	"./leagues/reports/user_affiliates/tableReports.js": 581,
	"./leagues/results/recordTableResponts": 572,
	"./leagues/results/recordTableResponts.js": 572,
	"./leagues/results/tableResults": 116,
	"./leagues/results/tableResults.js": 116,
	"./leagues/statistics": 1578,
	"./leagues/statistics.js": 1578,
	"./leagues/statistics/age": 585,
	"./leagues/statistics/age.js": 585,
	"./leagues/statistics/marketing": 583,
	"./leagues/statistics/marketing.js": 583,
	"./leagues/statistics/marketingvsregistros": 584,
	"./leagues/statistics/marketingvsregistros.js": 584,
	"./leagues/statistics/money": 582,
	"./leagues/statistics/money.js": 582,
	"./limitationsReport": 1579,
	"./limitationsReport.js": 1579,
	"./loading": 1580,
	"./loading.js": 1580,
	"./login": 1581,
	"./login.js": 1581,
	"./logsUserGeneral": 1582,
	"./logsUserGeneral.js": 1582,
	"./loteryReport": 1583,
	"./loteryReport.js": 1583,
	"./loyaltyLevelChangeHistory": 1584,
	"./loyaltyLevelChangeHistory.js": 1584,
	"./machine/AddMachineRegister": 1585,
	"./machine/AddMachineRegister.js": 1585,
	"./machine/addMachineManagement": 1586,
	"./machine/addMachineManagement.js": 1586,
	"./machine/cashier/advertising": 595,
	"./machine/cashier/advertising.js": 595,
	"./machine/cashier/cashier": 1587,
	"./machine/cashier/cashier.js": 1587,
	"./machine/cashier/tableAdvertising": 596,
	"./machine/cashier/tableAdvertising.js": 596,
	"./machine/configuration": 1588,
	"./machine/configuration.js": 1588,
	"./machine/configuration/changePassword": 1589,
	"./machine/configuration/changePassword.js": 1589,
	"./machine/configuration/changePassword/changePasswordView": 1590,
	"./machine/configuration/changePassword/changePasswordView.js": 1590,
	"./machine/configuration/generateToken": 1591,
	"./machine/configuration/generateToken.js": 1591,
	"./machine/configuration/generateToken/filter": 1592,
	"./machine/configuration/generateToken/filter.js": 1592,
	"./machine/configuration/generateToken/table": 1593,
	"./machine/configuration/generateToken/table.js": 1593,
	"./machine/configuration/qrgoogle": 1594,
	"./machine/configuration/qrgoogle.js": 1594,
	"./machine/configuration/securityChanges": 1595,
	"./machine/configuration/securityChanges.js": 1595,
	"./machine/configuration/securityChanges/filter": 1030,
	"./machine/configuration/securityChanges/filter.js": 1030,
	"./machine/configuration/securityChanges/table": 597,
	"./machine/configuration/securityChanges/table.js": 597,
	"./machine/filter": 598,
	"./machine/filter.js": 598,
	"./machine/information": 1596,
	"./machine/information.js": 1596,
	"./machine/machineManagement": 1597,
	"./machine/machineManagement.js": 1597,
	"./machine/machineRegister": 1598,
	"./machine/machineRegister.js": 1598,
	"./machine/managePointsGraphics": 1599,
	"./machine/managePointsGraphics.js": 1599,
	"./machine/pagoNotaCobro": 1600,
	"./machine/pagoNotaCobro.js": 1600,
	"./machine/pagoNotaCobro/PagoNotaCobro": 1031,
	"./machine/pagoNotaCobro/PagoNotaCobro.js": 1031,
	"./machine/pagoNotaCobro/filterPagoNotaCobro": 602,
	"./machine/pagoNotaCobro/filterPagoNotaCobro.js": 602,
	"./machine/pagoNotaCobro/tablePagoNotaCobro": 603,
	"./machine/pagoNotaCobro/tablePagoNotaCobro.js": 603,
	"./machine/pagoPremioMaquina": 1601,
	"./machine/pagoPremioMaquina.js": 1601,
	"./machine/pagopremio/PagoPremio": 605,
	"./machine/pagopremio/PagoPremio.js": 605,
	"./machine/pagopremio/detailsPagoPremio": 607,
	"./machine/pagopremio/detailsPagoPremio.js": 607,
	"./machine/pagopremio/filterPagoPremio": 604,
	"./machine/pagopremio/filterPagoPremio.js": 604,
	"./machine/pagopremio/recordPagoPremio": 608,
	"./machine/pagopremio/recordPagoPremio.js": 608,
	"./machine/pagopremio/recordTablePagoPremio": 1602,
	"./machine/pagopremio/recordTablePagoPremio.js": 1602,
	"./machine/pagopremio/tablePagoPremio": 606,
	"./machine/pagopremio/tablePagoPremio.js": 606,
	"./machine/pointsGraphics/filter": 600,
	"./machine/pointsGraphics/filter.js": 600,
	"./machine/pointsGraphics/pointsList": 601,
	"./machine/pointsGraphics/pointsList.js": 601,
	"./machine/products2": 1603,
	"./machine/products2.js": 1603,
	"./machine/products2/categories-products/filter": 609,
	"./machine/products2/categories-products/filter.js": 609,
	"./machine/products2/categories-products/table": 610,
	"./machine/products2/categories-products/table.js": 610,
	"./machine/products2/categoriesProducts": 1604,
	"./machine/products2/categoriesProducts.js": 1604,
	"./machine/products2/partners-games/filter": 611,
	"./machine/products2/partners-games/filter.js": 611,
	"./machine/products2/partners-games/table": 612,
	"./machine/products2/partners-games/table.js": 612,
	"./machine/products2/partners-products/filter": 613,
	"./machine/products2/partners-products/filter.js": 613,
	"./machine/products2/partners-products/table": 614,
	"./machine/products2/partners-products/table.js": 614,
	"./machine/products2/partners-providers/filter": 615,
	"./machine/products2/partners-providers/filter.js": 615,
	"./machine/products2/partners-providers/table": 616,
	"./machine/products2/partners-providers/table.js": 616,
	"./machine/products2/partners-subProviders/filter": 617,
	"./machine/products2/partners-subProviders/filter.js": 617,
	"./machine/products2/partners-subProviders/table": 618,
	"./machine/products2/partners-subProviders/table.js": 618,
	"./machine/products2/partners-tipoproducto/filter": 619,
	"./machine/products2/partners-tipoproducto/filter.js": 619,
	"./machine/products2/partners-tipoproducto/table": 620,
	"./machine/products2/partners-tipoproducto/table.js": 620,
	"./machine/products2/partnersGames": 1605,
	"./machine/products2/partnersGames.js": 1605,
	"./machine/products2/partnersProducts": 1606,
	"./machine/products2/partnersProducts.js": 1606,
	"./machine/products2/partnersProviders": 1607,
	"./machine/products2/partnersProviders.js": 1607,
	"./machine/products2/partnersSubProviders": 1608,
	"./machine/products2/partnersSubProviders.js": 1608,
	"./machine/products2/partnersTypeProduct": 1609,
	"./machine/products2/partnersTypeProduct.js": 1609,
	"./machine/reports": 1610,
	"./machine/reports.js": 1610,
	"./machine/reports/betsReport": 1611,
	"./machine/reports/betsReport.js": 1611,
	"./machine/reports/betsReport/detailsReport": 1612,
	"./machine/reports/betsReport/detailsReport.js": 1612,
	"./machine/reports/betsReport/filterReport": 621,
	"./machine/reports/betsReport/filterReport.js": 621,
	"./machine/reports/betsReport/recordReport": 1613,
	"./machine/reports/betsReport/recordReport.js": 1613,
	"./machine/reports/betsReport/recordTableReport": 1614,
	"./machine/reports/betsReport/recordTableReport.js": 1614,
	"./machine/reports/betsReport/recordTableTransReport": 1615,
	"./machine/reports/betsReport/recordTableTransReport.js": 1615,
	"./machine/reports/betsReport/recordTransReport": 623,
	"./machine/reports/betsReport/recordTransReport.js": 623,
	"./machine/reports/betsReport/tableReport": 622,
	"./machine/reports/betsReport/tableReport.js": 622,
	"./machine/reports/casinoGamesReport": 1616,
	"./machine/reports/casinoGamesReport.js": 1616,
	"./machine/reports/casinoReport/detailsCasinoReport": 626,
	"./machine/reports/casinoReport/detailsCasinoReport.js": 626,
	"./machine/reports/casinoReport/filterCasinoReport": 624,
	"./machine/reports/casinoReport/filterCasinoReport.js": 624,
	"./machine/reports/casinoReport/recordCasinoReport": 627,
	"./machine/reports/casinoReport/recordCasinoReport.js": 627,
	"./machine/reports/casinoReport/recordTableCasinoReport": 1617,
	"./machine/reports/casinoReport/recordTableCasinoReport.js": 1617,
	"./machine/reports/casinoReport/tableCasinoReport": 625,
	"./machine/reports/casinoReport/tableCasinoReport.js": 625,
	"./machine/reports/depositReport": 1618,
	"./machine/reports/depositReport.js": 1618,
	"./machine/reports/deposit_report/detailsDepositReports": 1032,
	"./machine/reports/deposit_report/detailsDepositReports.js": 1032,
	"./machine/reports/deposit_report/filterDepositReports": 628,
	"./machine/reports/deposit_report/filterDepositReports.js": 628,
	"./machine/reports/deposit_report/recordDepositReports": 630,
	"./machine/reports/deposit_report/recordDepositReports.js": 630,
	"./machine/reports/deposit_report/recordTableDepositReports": 1619,
	"./machine/reports/deposit_report/recordTableDepositReports.js": 1619,
	"./machine/reports/deposit_report/tableDepositReports": 629,
	"./machine/reports/deposit_report/tableDepositReports.js": 629,
	"./machine/reports/flujoCaja": 1620,
	"./machine/reports/flujoCaja.js": 1620,
	"./machine/reports/flujocaja/detailsFlujoCaja": 633,
	"./machine/reports/flujocaja/detailsFlujoCaja.js": 633,
	"./machine/reports/flujocaja/filterFlujoCaja": 631,
	"./machine/reports/flujocaja/filterFlujoCaja.js": 631,
	"./machine/reports/flujocaja/recordFlujoCaja": 634,
	"./machine/reports/flujocaja/recordFlujoCaja.js": 634,
	"./machine/reports/flujocaja/recordTableFlujoCaja": 1621,
	"./machine/reports/flujocaja/recordTableFlujoCaja.js": 1621,
	"./machine/reports/flujocaja/tableFlujoCaja": 632,
	"./machine/reports/flujocaja/tableFlujoCaja.js": 632,
	"./machine/reports/log/log": 635,
	"./machine/reports/log/log.js": 635,
	"./machine/reports/logReport": 1622,
	"./machine/reports/logReport.js": 1622,
	"./machine/reports/updates/filter": 636,
	"./machine/reports/updates/filter.js": 636,
	"./machine/reports/updates/table": 637,
	"./machine/reports/updates/table.js": 637,
	"./machine/reports/updatesReport": 1623,
	"./machine/reports/updatesReport.js": 1623,
	"./machine/reports/userAfilliatesReport": 1624,
	"./machine/reports/userAfilliatesReport.js": 1624,
	"./machine/reports/user_affiliates/detailsReports": 1625,
	"./machine/reports/user_affiliates/detailsReports.js": 1625,
	"./machine/reports/user_affiliates/filterReports": 638,
	"./machine/reports/user_affiliates/filterReports.js": 638,
	"./machine/reports/user_affiliates/recordReports": 1626,
	"./machine/reports/user_affiliates/recordReports.js": 1626,
	"./machine/reports/user_affiliates/recordTableReports": 1627,
	"./machine/reports/user_affiliates/recordTableReports.js": 1627,
	"./machine/reports/user_affiliates/tableReports": 639,
	"./machine/reports/user_affiliates/tableReports.js": 639,
	"./machine/reports/withdrawalRequests": 1628,
	"./machine/reports/withdrawalRequests.js": 1628,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests": 642,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests.js": 642,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest": 640,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest.js": 640,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest": 1629,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest.js": 1629,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest": 643,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest.js": 643,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest": 641,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest.js": 641,
	"./machine/results/recordTableResponts": 1630,
	"./machine/results/recordTableResponts.js": 1630,
	"./machine/results/tableResults": 1631,
	"./machine/results/tableResults.js": 1631,
	"./machine/statistics": 1632,
	"./machine/statistics.js": 1632,
	"./machine/statistics/age": 647,
	"./machine/statistics/age.js": 647,
	"./machine/statistics/marketing": 645,
	"./machine/statistics/marketing.js": 645,
	"./machine/statistics/marketingvsregistros": 646,
	"./machine/statistics/marketingvsregistros.js": 646,
	"./machine/statistics/money": 644,
	"./machine/statistics/money.js": 644,
	"./machine/table": 599,
	"./machine/table.js": 599,
	"./management/activateRegistration/filter": 204,
	"./management/activateRegistration/filter.js": 204,
	"./management/activateRegistration/response": 205,
	"./management/activateRegistration/response.js": 205,
	"./management/coupons/coupons": 447,
	"./management/coupons/coupons.js": 447,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw": 512,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw.js": 512,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw": 511,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw.js": 511,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw": 514,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw.js": 514,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw": 513,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw.js": 513,
	"./management/faltan.txt": 1962,
	"./management/managementClaims/filter": 648,
	"./management/managementClaims/filter.js": 648,
	"./management/managementClaims/table": 649,
	"./management/managementClaims/table.js": 649,
	"./management/managementContact/details": 162,
	"./management/managementContact/details.js": 162,
	"./management/managementContact/detailsTable": 650,
	"./management/managementContact/detailsTable.js": 650,
	"./management/managementContact/filterManagementContact": 651,
	"./management/managementContact/filterManagementContact.js": 651,
	"./management/managementContact/tableManagementContact": 652,
	"./management/managementContact/tableManagementContact.js": 652,
	"./management/managementContactUser/filter": 653,
	"./management/managementContactUser/filter.js": 653,
	"./management/managementContactUser/table": 654,
	"./management/managementContactUser/table.js": 654,
	"./management/managementGenericForms/filter": 655,
	"./management/managementGenericForms/filter.js": 655,
	"./management/managementGenericForms/table": 656,
	"./management/managementGenericForms/table.js": 656,
	"./management/quotaRetraction/Retraction": 657,
	"./management/quotaRetraction/Retraction.js": 657,
	"./management/quotaRetraction/search": 1033,
	"./management/quotaRetraction/search.js": 1033,
	"./management/registerFast/filterRegisterFast": 658,
	"./management/registerFast/filterRegisterFast.js": 658,
	"./management/registerFast/tableRegisterFast": 659,
	"./management/registerFast/tableRegisterFast.js": 659,
	"./management/reprintCheck/filterReprintCheck": 660,
	"./management/reprintCheck/filterReprintCheck.js": 660,
	"./management/reprintCheck/tableReprintCheck": 661,
	"./management/reprintCheck/tableReprintCheck.js": 661,
	"./management/restrictUser/filter": 662,
	"./management/restrictUser/filter.js": 662,
	"./management/restrictUser/table": 663,
	"./management/restrictUser/table.js": 663,
	"./management/reversionReload/filterReversionReload": 664,
	"./management/reversionReload/filterReversionReload.js": 664,
	"./management/reversionReload/tableReversionReload": 665,
	"./management/reversionReload/tableReversionReload.js": 665,
	"./management/usersVerification/information": 117,
	"./management/usersVerification/information.js": 117,
	"./management/usersVerification/informationJumio": 666,
	"./management/usersVerification/informationJumio.js": 666,
	"./managementClaims": 1633,
	"./managementClaims.js": 1633,
	"./managementContact": 1634,
	"./managementContact.js": 1634,
	"./managementContactUser": 1635,
	"./managementContactUser.js": 1635,
	"./managementGenericForms": 1636,
	"./managementGenericForms.js": 1636,
	"./menu": 11,
	"./menu.js": 11,
	"./menuBonus": 1637,
	"./menuBonus.js": 1637,
	"./menuBuilder": 1638,
	"./menuBuilder.js": 1638,
	"./menuMarketing": 1639,
	"./menuMarketing.js": 1639,
	"./menus": 1640,
	"./menus.js": 1640,
	"./messages/bannerInvasive": 1641,
	"./messages/bannerInvasive.js": 1641,
	"./messages/bannerInvasive/filter": 669,
	"./messages/bannerInvasive/filter.js": 669,
	"./messages/bannerInvasive/table": 670,
	"./messages/bannerInvasive/table.js": 670,
	"./messages/fringe": 1642,
	"./messages/fringe.js": 1642,
	"./messages/fringe/filter": 671,
	"./messages/fringe/filter.js": 671,
	"./messages/fringe/table": 672,
	"./messages/fringe/table.js": 672,
	"./messages/messageIntern/filter": 118,
	"./messages/messageIntern/filter.js": 118,
	"./messages/messageIntern/table": 119,
	"./messages/messageIntern/table.js": 119,
	"./messages/messageInternAgent/filter": 673,
	"./messages/messageInternAgent/filter.js": 673,
	"./messages/messageInternAgent/table": 674,
	"./messages/messageInternAgent/table.js": 674,
	"./messages/messageInternal": 1643,
	"./messages/messageInternal.js": 1643,
	"./messages/messageInternalAgent": 1644,
	"./messages/messageInternalAgent.js": 1644,
	"./messages/messageList": 1645,
	"./messages/messageList.js": 1645,
	"./messages/popup": 1646,
	"./messages/popup.js": 1646,
	"./messages/popup/filter": 675,
	"./messages/popup/filter.js": 675,
	"./messages/popup/table": 676,
	"./messages/popup/table.js": 676,
	"./messagesOld/messageIntern/filter": 1647,
	"./messagesOld/messageIntern/filter.js": 1647,
	"./messagesOld/messageIntern/table": 1648,
	"./messagesOld/messageIntern/table.js": 1648,
	"./messagesOld/messageList": 1649,
	"./messagesOld/messageList.js": 1649,
	"./myComissionsReport": 1650,
	"./myComissionsReport.js": 1650,
	"./myConfiguration/changeMyPassword": 1651,
	"./myConfiguration/changeMyPassword.js": 1651,
	"./myConfiguration/myInfoBetShop": 1652,
	"./myConfiguration/myInfoBetShop.js": 1652,
	"./myConfiguration/myInfoCustomer": 1653,
	"./myConfiguration/myInfoCustomer.js": 1653,
	"./myConfiguration/myInformation": 1654,
	"./myConfiguration/myInformation.js": 1654,
	"./myConfiguration/qrgoogle": 1655,
	"./myConfiguration/qrgoogle.js": 1655,
	"./notesUser": 1656,
	"./notesUser.js": 1656,
	"./notifications": 1004,
	"./notifications.js": 1004,
	"./operatorResponsibility": 1657,
	"./operatorResponsibility.js": 1657,
	"./ownersIncome": 1658,
	"./ownersIncome.js": 1658,
	"./ownersIncomeSecondLevel": 1659,
	"./ownersIncomeSecondLevel.js": 1659,
	"./pagoNotaRetiro": 1660,
	"./pagoNotaRetiro.js": 1660,
	"./pagoPremio": 1661,
	"./pagoPremio.js": 1661,
	"./pagoPremioVirtuales": 1662,
	"./pagoPremioVirtuales.js": 1662,
	"./paidPendingAwards": 1663,
	"./paidPendingAwards.js": 1663,
	"./partner/PartnerSettings": 1664,
	"./partner/PartnerSettings.js": 1664,
	"./partner/PartnerSettingsOld": 1665,
	"./partner/PartnerSettingsOld.js": 1665,
	"./partner/TRM": 1666,
	"./partner/TRM.js": 1666,
	"./partner/TRM/filter": 691,
	"./partner/TRM/filter.js": 691,
	"./partner/TRM/table": 692,
	"./partner/TRM/table.js": 692,
	"./partner/configuration": 1667,
	"./partner/configuration.js": 1667,
	"./partner/configuration/filter": 120,
	"./partner/configuration/filter.js": 120,
	"./partner/configuration/settings": 121,
	"./partner/configuration/settings.js": 121,
	"./partner/configurationControl": 1668,
	"./partner/configurationControl.js": 1668,
	"./partner/configurationControl/filter": 693,
	"./partner/configurationControl/filter.js": 693,
	"./partner/configurationControl/table": 694,
	"./partner/configurationControl/table.js": 694,
	"./partner/configurationControl2": 1669,
	"./partner/configurationControl2.js": 1669,
	"./partner/configurationControl2/filter": 695,
	"./partner/configurationControl2/filter.js": 695,
	"./partner/configurationControl2/table": 696,
	"./partner/configurationControl2/table.js": 696,
	"./partner/configurationOld/filter": 1670,
	"./partner/configurationOld/filter.js": 1670,
	"./partner/configurationOld/settings": 1671,
	"./partner/configurationOld/settings.js": 1671,
	"./partner/configurationSEO": 1672,
	"./partner/configurationSEO.js": 1672,
	"./partner/configurationSEO/filter": 697,
	"./partner/configurationSEO/filter.js": 697,
	"./partner/configurationSEO/settings": 698,
	"./partner/configurationSEO/settings.js": 698,
	"./partner/countries": 1673,
	"./partner/countries.js": 1673,
	"./partner/countries/countries": 699,
	"./partner/countries/countries.js": 699,
	"./partner/menusUser": 1674,
	"./partner/menusUser.js": 1674,
	"./partner/menusUser/filter": 700,
	"./partner/menusUser/filter.js": 700,
	"./partner/menusUser/table": 701,
	"./partner/menusUser/table.js": 701,
	"./partner/partner-list/filter": 689,
	"./partner/partner-list/filter.js": 689,
	"./partner/partner-list/table": 690,
	"./partner/partner-list/table.js": 690,
	"./partner/partnertManagement": 1675,
	"./partner/partnertManagement.js": 1675,
	"./partner/products": 1676,
	"./partner/products.js": 1676,
	"./partner/products/categories-products/filter": 702,
	"./partner/products/categories-products/filter.js": 702,
	"./partner/products/categories-products/table": 703,
	"./partner/products/categories-products/table.js": 703,
	"./partner/products/categoriesProducts": 1677,
	"./partner/products/categoriesProducts.js": 1677,
	"./partner/products/partners-products/filter": 704,
	"./partner/products/partners-products/filter.js": 704,
	"./partner/products/partners-products/table": 705,
	"./partner/products/partners-products/table.js": 705,
	"./partner/products/partners-providers/filter": 706,
	"./partner/products/partners-providers/filter.js": 706,
	"./partner/products/partners-providers/table": 707,
	"./partner/products/partners-providers/table.js": 707,
	"./partner/products/partners-subProviders/filter": 708,
	"./partner/products/partners-subProviders/filter.js": 708,
	"./partner/products/partners-subProviders/table": 709,
	"./partner/products/partners-subProviders/table.js": 709,
	"./partner/products/partners-tipoproducto/filter": 710,
	"./partner/products/partners-tipoproducto/filter.js": 710,
	"./partner/products/partners-tipoproducto/table": 711,
	"./partner/products/partners-tipoproducto/table.js": 711,
	"./partner/products/partnersProducts": 1678,
	"./partner/products/partnersProducts.js": 1678,
	"./partner/products/partnersProviders": 1679,
	"./partner/products/partnersProviders.js": 1679,
	"./partner/products/partnersSubProviders": 1680,
	"./partner/products/partnersSubProviders.js": 1680,
	"./partner/products/partnersTypeProduct": 1681,
	"./partner/products/partnersTypeProduct.js": 1681,
	"./partner/products/products-banks/filter": 712,
	"./partner/products/products-banks/filter.js": 712,
	"./partner/products/products-banks/table": 713,
	"./partner/products/products-banks/table.js": 713,
	"./partner/products/products-cryptoNetwork/filter": 714,
	"./partner/products/products-cryptoNetwork/filter.js": 714,
	"./partner/products/products-cryptoNetwork/table": 715,
	"./partner/products/products-cryptoNetwork/table.js": 715,
	"./partner/products/products-franchises/filter": 716,
	"./partner/products/products-franchises/filter.js": 716,
	"./partner/products/products-franchises/table": 717,
	"./partner/products/products-franchises/table.js": 717,
	"./partner/products/productsBanks": 1682,
	"./partner/products/productsBanks.js": 1682,
	"./partner/products/productsCryptoNetwork": 1683,
	"./partner/products/productsCryptoNetwork.js": 1683,
	"./partner/products/productsFranchises": 1684,
	"./partner/products/productsFranchises.js": 1684,
	"./partner/products2": 1685,
	"./partner/products2.js": 1685,
	"./partner/products2/banks-partners/filter": 718,
	"./partner/products2/banks-partners/filter.js": 718,
	"./partner/products2/banks-partners/table": 719,
	"./partner/products2/banks-partners/table.js": 719,
	"./partner/products2/categories-products/filter": 720,
	"./partner/products2/categories-products/filter.js": 720,
	"./partner/products2/categories-products/table": 721,
	"./partner/products2/categories-products/table.js": 721,
	"./partner/products2/categoriesProducts": 1686,
	"./partner/products2/categoriesProducts.js": 1686,
	"./partner/products2/enablement-products/filter": 722,
	"./partner/products2/enablement-products/filter.js": 722,
	"./partner/products2/enablement-products/table": 723,
	"./partner/products2/enablement-products/table.js": 723,
	"./partner/products2/enablementProducts": 1687,
	"./partner/products2/enablementProducts.js": 1687,
	"./partner/products2/franchises-partner/filter": 724,
	"./partner/products2/franchises-partner/filter.js": 724,
	"./partner/products2/franchises-partner/table": 725,
	"./partner/products2/franchises-partner/table.js": 725,
	"./partner/products2/partners-categories/filter": 726,
	"./partner/products2/partners-categories/filter.js": 726,
	"./partner/products2/partners-categories/table": 727,
	"./partner/products2/partners-categories/table.js": 727,
	"./partner/products2/partners-credentialsSubProviders/filter": 728,
	"./partner/products2/partners-credentialsSubProviders/filter.js": 728,
	"./partner/products2/partners-credentialsSubProviders/table": 729,
	"./partner/products2/partners-credentialsSubProviders/table.js": 729,
	"./partner/products2/partners-games/filter": 730,
	"./partner/products2/partners-games/filter.js": 730,
	"./partner/products2/partners-games/table": 731,
	"./partner/products2/partners-games/table.js": 731,
	"./partner/products2/partners-products/filter": 732,
	"./partner/products2/partners-products/filter.js": 732,
	"./partner/products2/partners-products/table": 733,
	"./partner/products2/partners-products/table.js": 733,
	"./partner/products2/partners-providers-order/filter": 1688,
	"./partner/products2/partners-providers-order/filter.js": 1688,
	"./partner/products2/partners-providers-order/table": 1689,
	"./partner/products2/partners-providers-order/table.js": 1689,
	"./partner/products2/partners-providers/filter": 734,
	"./partner/products2/partners-providers/filter.js": 734,
	"./partner/products2/partners-providers/table": 735,
	"./partner/products2/partners-providers/table.js": 735,
	"./partner/products2/partners-subProviders-order/filter": 736,
	"./partner/products2/partners-subProviders-order/filter.js": 736,
	"./partner/products2/partners-subProviders-order/table": 737,
	"./partner/products2/partners-subProviders-order/table.js": 737,
	"./partner/products2/partners-subProviders/filter": 738,
	"./partner/products2/partners-subProviders/filter.js": 738,
	"./partner/products2/partners-subProviders/table": 739,
	"./partner/products2/partners-subProviders/table.js": 739,
	"./partner/products2/partners-tipoproducto/filter": 740,
	"./partner/products2/partners-tipoproducto/filter.js": 740,
	"./partner/products2/partners-tipoproducto/table": 741,
	"./partner/products2/partners-tipoproducto/table.js": 741,
	"./partner/products2/partnersBanks": 1690,
	"./partner/products2/partnersBanks.js": 1690,
	"./partner/products2/partnersCategories": 1691,
	"./partner/products2/partnersCategories.js": 1691,
	"./partner/products2/partnersCredentialsSubProviders": 1692,
	"./partner/products2/partnersCredentialsSubProviders.js": 1692,
	"./partner/products2/partnersFranchises": 1693,
	"./partner/products2/partnersFranchises.js": 1693,
	"./partner/products2/partnersGames": 1694,
	"./partner/products2/partnersGames.js": 1694,
	"./partner/products2/partnersProducts": 1695,
	"./partner/products2/partnersProducts.js": 1695,
	"./partner/products2/partnersProviders": 1696,
	"./partner/products2/partnersProviders.js": 1696,
	"./partner/products2/partnersSubProviders": 1697,
	"./partner/products2/partnersSubProviders.js": 1697,
	"./partner/products2/partnersSubProvidersOrder": 1698,
	"./partner/products2/partnersSubProvidersOrder.js": 1698,
	"./partner/products2/partnersTypeProduct": 1699,
	"./partner/products2/partnersTypeProduct.js": 1699,
	"./partner/reports": 1700,
	"./partner/reports.js": 1700,
	"./partner/reports/autoexclusionUsers": 1701,
	"./partner/reports/autoexclusionUsers.js": 1701,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers": 744,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 744,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers": 742,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 742,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers": 1034,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1034,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 745,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 745,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers": 743,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 743,
	"./partner/reports/balanceAdjustments": 1702,
	"./partner/reports/balanceAdjustments.js": 1702,
	"./partner/reports/balanceAdjustments/filter": 746,
	"./partner/reports/balanceAdjustments/filter.js": 746,
	"./partner/reports/balanceAdjustments/table": 747,
	"./partner/reports/balanceAdjustments/table.js": 747,
	"./partner/reports/balanceHistory": 1703,
	"./partner/reports/balanceHistory.js": 1703,
	"./partner/reports/balanceHistory/filter": 748,
	"./partner/reports/balanceHistory/filter.js": 748,
	"./partner/reports/balanceHistory/table": 749,
	"./partner/reports/balanceHistory/table.js": 749,
	"./partner/reports/balanceHistoryBetShop": 1704,
	"./partner/reports/balanceHistoryBetShop.js": 1704,
	"./partner/reports/balanceHistoryBetShop/filter": 750,
	"./partner/reports/balanceHistoryBetShop/filter.js": 750,
	"./partner/reports/balanceHistoryBetShop/table": 751,
	"./partner/reports/balanceHistoryBetShop/table.js": 751,
	"./partner/reports/balanceUsers": 1705,
	"./partner/reports/balanceUsers.js": 1705,
	"./partner/reports/balanceUsers/filter": 752,
	"./partner/reports/balanceUsers/filter.js": 752,
	"./partner/reports/balanceUsers/record": 754,
	"./partner/reports/balanceUsers/record.js": 754,
	"./partner/reports/balanceUsers/resume": 755,
	"./partner/reports/balanceUsers/resume.js": 755,
	"./partner/reports/balanceUsers/table": 753,
	"./partner/reports/balanceUsers/table.js": 753,
	"./partner/reports/betsReport": 1706,
	"./partner/reports/betsReport.js": 1706,
	"./partner/reports/betsReport/detailsReport": 1707,
	"./partner/reports/betsReport/detailsReport.js": 1707,
	"./partner/reports/betsReport/filterReport": 756,
	"./partner/reports/betsReport/filterReport.js": 756,
	"./partner/reports/betsReport/recordReport": 760,
	"./partner/reports/betsReport/recordReport.js": 760,
	"./partner/reports/betsReport/recordTableReport": 761,
	"./partner/reports/betsReport/recordTableReport.js": 761,
	"./partner/reports/betsReport/recordTableTransReport": 759,
	"./partner/reports/betsReport/recordTableTransReport.js": 759,
	"./partner/reports/betsReport/recordTransReport": 758,
	"./partner/reports/betsReport/recordTransReport.js": 758,
	"./partner/reports/betsReport/tableReport": 757,
	"./partner/reports/betsReport/tableReport.js": 757,
	"./partner/reports/bonusReport": 1708,
	"./partner/reports/bonusReport.js": 1708,
	"./partner/reports/bonusReport/detailsBonusReport": 764,
	"./partner/reports/bonusReport/detailsBonusReport.js": 764,
	"./partner/reports/bonusReport/filterBonusReport": 762,
	"./partner/reports/bonusReport/filterBonusReport.js": 762,
	"./partner/reports/bonusReport/recordBonusReport": 765,
	"./partner/reports/bonusReport/recordBonusReport.js": 765,
	"./partner/reports/bonusReport/recordTableBonusReport": 766,
	"./partner/reports/bonusReport/recordTableBonusReport.js": 766,
	"./partner/reports/bonusReport/tableBonusReport": 763,
	"./partner/reports/bonusReport/tableBonusReport.js": 763,
	"./partner/reports/casinoGamesReport": 1709,
	"./partner/reports/casinoGamesReport.js": 1709,
	"./partner/reports/casinoReport/detailsCasinoReport": 769,
	"./partner/reports/casinoReport/detailsCasinoReport.js": 769,
	"./partner/reports/casinoReport/filterCasinoReport": 767,
	"./partner/reports/casinoReport/filterCasinoReport.js": 767,
	"./partner/reports/casinoReport/recordCasinoReport": 770,
	"./partner/reports/casinoReport/recordCasinoReport.js": 770,
	"./partner/reports/casinoReport/recordTableCasinoReport": 771,
	"./partner/reports/casinoReport/recordTableCasinoReport.js": 771,
	"./partner/reports/casinoReport/tableCasinoReport": 768,
	"./partner/reports/casinoReport/tableCasinoReport.js": 768,
	"./partner/reports/comissionsReport": 1710,
	"./partner/reports/comissionsReport.js": 1710,
	"./partner/reports/comissions_report/filter": 772,
	"./partner/reports/comissions_report/filter.js": 772,
	"./partner/reports/comissions_report/table": 773,
	"./partner/reports/comissions_report/table.js": 773,
	"./partner/reports/depositReport": 1711,
	"./partner/reports/depositReport.js": 1711,
	"./partner/reports/deposit_report/detailsDepositReports": 1035,
	"./partner/reports/deposit_report/detailsDepositReports.js": 1035,
	"./partner/reports/deposit_report/filterDepositReports": 774,
	"./partner/reports/deposit_report/filterDepositReports.js": 774,
	"./partner/reports/deposit_report/recordDepositReports": 776,
	"./partner/reports/deposit_report/recordDepositReports.js": 776,
	"./partner/reports/deposit_report/recordTableDepositReports": 777,
	"./partner/reports/deposit_report/recordTableDepositReports.js": 777,
	"./partner/reports/deposit_report/tableDepositReports": 775,
	"./partner/reports/deposit_report/tableDepositReports.js": 775,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido": 778,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 778,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido": 779,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido.js": 779,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido": 780,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido.js": 780,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido": 122,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 122,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido": 781,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido.js": 781,
	"./partner/reports/historicalCashFlow": 1712,
	"./partner/reports/historicalCashFlow.js": 1712,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow": 784,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow.js": 784,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow": 782,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow.js": 782,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow": 785,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow.js": 785,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow": 786,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 786,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow": 783,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow.js": 783,
	"./partner/reports/historyMovement": 1713,
	"./partner/reports/historyMovement.js": 1713,
	"./partner/reports/historyMovement/filter": 787,
	"./partner/reports/historyMovement/filter.js": 787,
	"./partner/reports/historyMovement/table": 788,
	"./partner/reports/historyMovement/table.js": 788,
	"./partner/reports/informeCasino/detailsInformeCasino": 1714,
	"./partner/reports/informeCasino/detailsInformeCasino.js": 1714,
	"./partner/reports/informeCasino/filterInformeCasino": 1715,
	"./partner/reports/informeCasino/filterInformeCasino.js": 1715,
	"./partner/reports/informeCasino/recordInformeCasino": 1716,
	"./partner/reports/informeCasino/recordInformeCasino.js": 1716,
	"./partner/reports/informeCasino/recordTableInformeCasino": 1717,
	"./partner/reports/informeCasino/recordTableInformeCasino.js": 1717,
	"./partner/reports/informeCasino/tableInformeCasino": 1718,
	"./partner/reports/informeCasino/tableInformeCasino.js": 1718,
	"./partner/reports/informeGerencial": 1719,
	"./partner/reports/informeGerencial.js": 1719,
	"./partner/reports/informeGerencial/detailsInformeGerencial": 791,
	"./partner/reports/informeGerencial/detailsInformeGerencial.js": 791,
	"./partner/reports/informeGerencial/filterInformeGerencial": 789,
	"./partner/reports/informeGerencial/filterInformeGerencial.js": 789,
	"./partner/reports/informeGerencial/recordInformeGerencial": 792,
	"./partner/reports/informeGerencial/recordInformeGerencial.js": 792,
	"./partner/reports/informeGerencial/recordTableInformeGerencial": 793,
	"./partner/reports/informeGerencial/recordTableInformeGerencial.js": 793,
	"./partner/reports/informeGerencial/tableInformeGerencial": 790,
	"./partner/reports/informeGerencial/tableInformeGerencial.js": 790,
	"./partner/reports/landingReport/detailsLandingReport": 1720,
	"./partner/reports/landingReport/detailsLandingReport.js": 1720,
	"./partner/reports/landingReport/filterLandingReport": 1721,
	"./partner/reports/landingReport/filterLandingReport.js": 1721,
	"./partner/reports/landingReport/recordLandingReport": 1722,
	"./partner/reports/landingReport/recordLandingReport.js": 1722,
	"./partner/reports/landingReport/recordTableLandingReport": 1723,
	"./partner/reports/landingReport/recordTableLandingReport.js": 1723,
	"./partner/reports/landingReport/tableLandingReport": 1724,
	"./partner/reports/landingReport/tableLandingReport.js": 1724,
	"./partner/reports/logsUser/filter": 1725,
	"./partner/reports/logsUser/filter.js": 1725,
	"./partner/reports/logsUser/table": 1726,
	"./partner/reports/logsUser/table.js": 1726,
	"./partner/reports/operatorResponsibility/filter": 1727,
	"./partner/reports/operatorResponsibility/filter.js": 1727,
	"./partner/reports/operatorResponsibility/table": 1728,
	"./partner/reports/operatorResponsibility/table.js": 1728,
	"./partner/reports/paidPendingAwards": 1729,
	"./partner/reports/paidPendingAwards.js": 1729,
	"./partner/reports/playersReport/detailsPlayersReport": 1730,
	"./partner/reports/playersReport/detailsPlayersReport.js": 1730,
	"./partner/reports/playersReport/filterPlayersReport": 1731,
	"./partner/reports/playersReport/filterPlayersReport.js": 1731,
	"./partner/reports/playersReport/recordPlayersReport": 1732,
	"./partner/reports/playersReport/recordPlayersReport.js": 1732,
	"./partner/reports/playersReport/recordTablePlayersReport": 797,
	"./partner/reports/playersReport/recordTablePlayersReport.js": 797,
	"./partner/reports/playersReport/tablePlayersReport": 1733,
	"./partner/reports/playersReport/tablePlayersReport.js": 1733,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1036,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1036,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar": 794,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 794,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1037,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1037,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 796,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 796,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar": 795,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 795,
	"./partner/reports/promotionalCodes/filter": 1734,
	"./partner/reports/promotionalCodes/filter.js": 1734,
	"./partner/reports/promotionalCodes/table": 1735,
	"./partner/reports/promotionalCodes/table.js": 1735,
	"./partner/reports/quotaRetraction/filter": 1736,
	"./partner/reports/quotaRetraction/filter.js": 1736,
	"./partner/reports/quotaRetraction/table": 1737,
	"./partner/reports/quotaRetraction/table.js": 1737,
	"./partner/reports/registeredDocument": 1738,
	"./partner/reports/registeredDocument.js": 1738,
	"./partner/reports/registeredDocuments/filter": 798,
	"./partner/reports/registeredDocuments/filter.js": 798,
	"./partner/reports/registeredDocuments/table": 799,
	"./partner/reports/registeredDocuments/table.js": 799,
	"./partner/reports/relationUserAggregator": 1739,
	"./partner/reports/relationUserAggregator.js": 1739,
	"./partner/reports/relationUserAggregator/filter": 800,
	"./partner/reports/relationUserAggregator/filter.js": 800,
	"./partner/reports/relationUserAggregator/table": 801,
	"./partner/reports/relationUserAggregator/table.js": 801,
	"./partner/reports/reportHash/filter": 1740,
	"./partner/reports/reportHash/filter.js": 1740,
	"./partner/reports/reportHash/table": 1741,
	"./partner/reports/reportHash/table.js": 1741,
	"./partner/reports/sessionsReport/detailsSessionsReport": 1742,
	"./partner/reports/sessionsReport/detailsSessionsReport.js": 1742,
	"./partner/reports/sessionsReport/filterSessionsReport": 1743,
	"./partner/reports/sessionsReport/filterSessionsReport.js": 1743,
	"./partner/reports/sessionsReport/recordSessionsReport": 1744,
	"./partner/reports/sessionsReport/recordSessionsReport.js": 1744,
	"./partner/reports/sessionsReport/recordTableSessionsReport": 1038,
	"./partner/reports/sessionsReport/recordTableSessionsReport.js": 1038,
	"./partner/reports/sessionsReport/tableSessionsReport": 1745,
	"./partner/reports/sessionsReport/tableSessionsReport.js": 1745,
	"./partner/reports/sportsTransactions": 1746,
	"./partner/reports/sportsTransactions.js": 1746,
	"./partner/reports/sportsTransactions/filter": 802,
	"./partner/reports/sportsTransactions/filter.js": 802,
	"./partner/reports/sportsTransactions/table": 803,
	"./partner/reports/sportsTransactions/table.js": 803,
	"./partner/reports/summaryCashFlow": 1747,
	"./partner/reports/summaryCashFlow.js": 1747,
	"./partner/reports/taxableEarnings/filter": 1748,
	"./partner/reports/taxableEarnings/filter.js": 1748,
	"./partner/reports/taxableEarnings/table": 1749,
	"./partner/reports/taxableEarnings/table.js": 1749,
	"./partner/reports/transfersReport/filter": 1750,
	"./partner/reports/transfersReport/filter.js": 1750,
	"./partner/reports/transfersReport/table": 1751,
	"./partner/reports/transfersReport/table.js": 1751,
	"./partner/reports/usuarioOnlineResumido": 1752,
	"./partner/reports/usuarioOnlineResumido.js": 1752,
	"./partner/reports/usuarioOnlineResumido/filter": 804,
	"./partner/reports/usuarioOnlineResumido/filter.js": 804,
	"./partner/reports/usuarioOnlineResumido/table": 805,
	"./partner/reports/usuarioOnlineResumido/table.js": 805,
	"./partner/reports/wallets": 1753,
	"./partner/reports/wallets.js": 1753,
	"./partner/reports/wallets/filter": 806,
	"./partner/reports/wallets/filter.js": 806,
	"./partner/reports/wallets/table": 807,
	"./partner/reports/wallets/table.js": 807,
	"./partner/templates": 1754,
	"./partner/templates.js": 1754,
	"./partner/templates/email": 1755,
	"./partner/templates/email.js": 1755,
	"./partner/templates/email/filter": 808,
	"./partner/templates/email/filter.js": 808,
	"./partner/templates/email/table": 809,
	"./partner/templates/email/table.js": 809,
	"./partner/templates/email/template": 810,
	"./partner/templates/email/template.js": 810,
	"./partner/templates/emailTemplate": 1756,
	"./partner/templates/emailTemplate.js": 1756,
	"./partner/templates/pdf": 1757,
	"./partner/templates/pdf.js": 1757,
	"./partner/templates/pdf/filter": 811,
	"./partner/templates/pdf/filter.js": 811,
	"./partner/templates/pdf/table": 812,
	"./partner/templates/pdf/table.js": 812,
	"./partner/templates/pdf/template": 813,
	"./partner/templates/pdf/template.js": 813,
	"./partner/templates/pdfTemplate": 1758,
	"./partner/templates/pdfTemplate.js": 1758,
	"./partner/templates/sms": 1759,
	"./partner/templates/sms.js": 1759,
	"./partner/templates/sms/filter": 814,
	"./partner/templates/sms/filter.js": 814,
	"./partner/templates/sms/table": 815,
	"./partner/templates/sms/table.js": 815,
	"./partner/templates/sms/template": 816,
	"./partner/templates/sms/template.js": 816,
	"./partner/templates/smsTemplate": 1760,
	"./partner/templates/smsTemplate.js": 1760,
	"./partners": 1761,
	"./partners.js": 1761,
	"./partnersCategories": 1762,
	"./partnersCategories.js": 1762,
	"./partnersProducts": 1763,
	"./partnersProducts.js": 1763,
	"./partnersProductsCountry": 1764,
	"./partnersProductsCountry.js": 1764,
	"./partnersProviders": 1765,
	"./partnersProviders.js": 1765,
	"./partnersTypeProduct": 1766,
	"./partnersTypeProduct.js": 1766,
	"./payPrizesLoyalty": 1767,
	"./payPrizesLoyalty.js": 1767,
	"./payhistoryview": 1768,
	"./payhistoryview.js": 1768,
	"./platformSpecific": 1769,
	"./platformSpecific.js": 1769,
	"./platformSpecific2": 1770,
	"./platformSpecific2.js": 1770,
	"./playerAccount": 1771,
	"./playerAccount.js": 1771,
	"./playerAccount2": 1772,
	"./playerAccount2.js": 1772,
	"./players": 3,
	"./players.js": 3,
	"./playersList": 1773,
	"./playersList.js": 1773,
	"./playersList2": 1774,
	"./playersList2.js": 1774,
	"./playersListAggregator": 1775,
	"./playersListAggregator.js": 1775,
	"./playersLists": 1776,
	"./playersLists.js": 1776,
	"./playersReport": 1777,
	"./playersReport.js": 1777,
	"./pointSettings": 1778,
	"./pointSettings.js": 1778,
	"./pointsUsers": 1779,
	"./pointsUsers.js": 1779,
	"./pokerReport": 1780,
	"./pokerReport.js": 1780,
	"./prices": 1781,
	"./prices.js": 1781,
	"./prizesLoyalty": 1782,
	"./prizesLoyalty.js": 1782,
	"./products": 1783,
	"./products.js": 1783,
	"./products/activeProviders/filterActiveProviders": 206,
	"./products/activeProviders/filterActiveProviders.js": 206,
	"./products/activeProviders/tableActiveProviders": 207,
	"./products/activeProviders/tableActiveProviders.js": 207,
	"./products/banks/filterBanks": 324,
	"./products/banks/filterBanks.js": 324,
	"./products/banks/tableBanks": 325,
	"./products/banks/tableBanks.js": 325,
	"./products/blockchain-networks/filterBlockchainNetworks": 381,
	"./products/blockchain-networks/filterBlockchainNetworks.js": 381,
	"./products/blockchain-networks/tableBlockchainNetworks": 382,
	"./products/blockchain-networks/tableBlockchainNetworks.js": 382,
	"./products/categories-products/detailsCategoriesProducts": 1021,
	"./products/categories-products/detailsCategoriesProducts.js": 1021,
	"./products/categories-products/filterCategoriesProducts": 426,
	"./products/categories-products/filterCategoriesProducts.js": 426,
	"./products/categories-products/recordCategoriesProducts": 1022,
	"./products/categories-products/recordCategoriesProducts.js": 1022,
	"./products/categories-products/recordTableCategoriesProducts": 428,
	"./products/categories-products/recordTableCategoriesProducts.js": 428,
	"./products/categories-products/tableCategoriesProducts": 427,
	"./products/categories-products/tableCategoriesProducts.js": 427,
	"./products/categories/detailsCategories": 1019,
	"./products/categories/detailsCategories.js": 1019,
	"./products/categories/filterCategories": 423,
	"./products/categories/filterCategories.js": 423,
	"./products/categories/recordCategories": 1020,
	"./products/categories/recordCategories.js": 1020,
	"./products/categories/recordTableCategories": 425,
	"./products/categories/recordTableCategories.js": 425,
	"./products/categories/tableCategories": 424,
	"./products/categories/tableCategories.js": 424,
	"./products/crypto-blockchain/filterCryptoBlockchain": 450,
	"./products/crypto-blockchain/filterCryptoBlockchain.js": 450,
	"./products/crypto-blockchain/tableCryptoBlockchain": 451,
	"./products/crypto-blockchain/tableCryptoBlockchain.js": 451,
	"./products/cryptos/filterCrypto": 452,
	"./products/cryptos/filterCrypto.js": 452,
	"./products/cryptos/tableCrypto": 453,
	"./products/cryptos/tableCrypto.js": 453,
	"./products/franchises/filterFranchises": 521,
	"./products/franchises/filterFranchises.js": 521,
	"./products/franchises/tableFranchises": 522,
	"./products/franchises/tableFranchises.js": 522,
	"./products/partners-products-country/detailsPartnersProductsCountry": 827,
	"./products/partners-products-country/detailsPartnersProductsCountry.js": 827,
	"./products/partners-products-country/filterPartnersProductsCountry": 825,
	"./products/partners-products-country/filterPartnersProductsCountry.js": 825,
	"./products/partners-products-country/recordPartnersProductsCountry": 828,
	"./products/partners-products-country/recordPartnersProductsCountry.js": 828,
	"./products/partners-products-country/recordTablePartnersProductsCountry": 829,
	"./products/partners-products-country/recordTablePartnersProductsCountry.js": 829,
	"./products/partners-products-country/tablePartnersProductsCountry": 826,
	"./products/partners-products-country/tablePartnersProductsCountry.js": 826,
	"./products/partners-products/detailsPartnersProducts": 823,
	"./products/partners-products/detailsPartnersProducts.js": 823,
	"./products/partners-products/filterPartnersProducts": 821,
	"./products/partners-products/filterPartnersProducts.js": 821,
	"./products/partners-products/recordPartnersProducts": 824,
	"./products/partners-products/recordPartnersProducts.js": 824,
	"./products/partners-products/recordTablePartnersProducts": 31,
	"./products/partners-products/recordTablePartnersProducts.js": 31,
	"./products/partners-products/tablePartnersProducts": 822,
	"./products/partners-products/tablePartnersProducts.js": 822,
	"./products/partners-providers/details": 832,
	"./products/partners-providers/details.js": 832,
	"./products/partners-providers/filter": 830,
	"./products/partners-providers/filter.js": 830,
	"./products/partners-providers/record": 833,
	"./products/partners-providers/record.js": 833,
	"./products/partners-providers/recordTable": 1784,
	"./products/partners-providers/recordTable.js": 1784,
	"./products/partners-providers/table": 831,
	"./products/partners-providers/table.js": 831,
	"./products/partners-tipoproducto/details": 836,
	"./products/partners-tipoproducto/details.js": 836,
	"./products/partners-tipoproducto/filter": 834,
	"./products/partners-tipoproducto/filter.js": 834,
	"./products/partners-tipoproducto/record": 837,
	"./products/partners-tipoproducto/record.js": 837,
	"./products/partners-tipoproducto/recordTable": 1785,
	"./products/partners-tipoproducto/recordTable.js": 1785,
	"./products/partners-tipoproducto/table": 835,
	"./products/partners-tipoproducto/table.js": 835,
	"./products/partners/filter": 817,
	"./products/partners/filter.js": 817,
	"./products/partners/table": 818,
	"./products/partners/table.js": 818,
	"./products/products/detailsProducts": 1039,
	"./products/products/detailsProducts.js": 1039,
	"./products/products/filterProducts": 859,
	"./products/products/filterProducts.js": 859,
	"./products/products/recordProducts": 1040,
	"./products/products/recordProducts.js": 1040,
	"./products/products/recordTableProducts": 861,
	"./products/products/recordTableProducts.js": 861,
	"./products/products/tableProducts": 860,
	"./products/products/tableProducts.js": 860,
	"./products/providers/detailsProviders": 68,
	"./products/providers/detailsProviders.js": 68,
	"./products/providers/filterProviders": 862,
	"./products/providers/filterProviders.js": 862,
	"./products/providers/recordProviders": 69,
	"./products/providers/recordProviders.js": 69,
	"./products/providers/recordTableProviders": 326,
	"./products/providers/recordTableProviders.js": 326,
	"./products/providers/tableProviders": 863,
	"./products/providers/tableProviders.js": 863,
	"./products/subProviders/filter": 864,
	"./products/subProviders/filter.js": 864,
	"./products/subProviders/table": 865,
	"./products/subProviders/table.js": 865,
	"./products/tags/detailsTags": 1041,
	"./products/tags/detailsTags.js": 1041,
	"./products/tags/filterTags": 866,
	"./products/tags/filterTags.js": 866,
	"./products/tags/recordTableTags": 867,
	"./products/tags/recordTableTags.js": 867,
	"./products/tags/recordTags": 1042,
	"./products/tags/recordTags.js": 1042,
	"./products/tags/tableTags": 868,
	"./products/tags/tableTags.js": 868,
	"./profile": 1786,
	"./profile.js": 1786,
	"./profileOptions": 1787,
	"./profileOptions.js": 1787,
	"./profileOptions2": 1788,
	"./profileOptions2.js": 1788,
	"./profileOptionsOld": 1789,
	"./profileOptionsOld.js": 1789,
	"./promotionalCasinoCampaings": 1790,
	"./promotionalCasinoCampaings.js": 1790,
	"./promotionalCodes": 1791,
	"./promotionalCodes.js": 1791,
	"./promotionalSportbookCampaings": 1792,
	"./promotionalSportbookCampaings.js": 1792,
	"./providers": 1793,
	"./providers.js": 1793,
	"./qualifying": 1794,
	"./qualifying.js": 1794,
	"./quotaRetraction": 1795,
	"./quotaRetraction.js": 1795,
	"./quotaRetractionReport": 1796,
	"./quotaRetractionReport.js": 1796,
	"./recargarCredito": 1797,
	"./recargarCredito.js": 1797,
	"./recargarCreditoAgente": 1798,
	"./recargarCreditoAgente.js": 1798,
	"./referralsAwardsReport": 1799,
	"./referralsAwardsReport.js": 1799,
	"./referralsReport": 1800,
	"./referralsReport.js": 1800,
	"./registerFast": 1801,
	"./registerFast.js": 1801,
	"./registeredDocument": 1802,
	"./registeredDocument.js": 1802,
	"./registeredDocuments": 1803,
	"./registeredDocuments.js": 1803,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports": 439,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports.js": 439,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports": 440,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports.js": 440,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports": 441,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports.js": 441,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports": 442,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports.js": 442,
	"./regulations/futureEvents/filterFutureEventsReports": 523,
	"./regulations/futureEvents/filterFutureEventsReports.js": 523,
	"./regulations/futureEvents/tableFutureEventsReports": 524,
	"./regulations/futureEvents/tableFutureEventsReports.js": 524,
	"./regulations/gamesPerformance/filterGamesPerformanceReports": 525,
	"./regulations/gamesPerformance/filterGamesPerformanceReports.js": 525,
	"./regulations/gamesPerformance/tableGamesPerformanceReports": 526,
	"./regulations/gamesPerformance/tableGamesPerformanceReports.js": 526,
	"./regulations/getReportStructureGames/filterGetReportStructureGames": 527,
	"./regulations/getReportStructureGames/filterGetReportStructureGames.js": 527,
	"./regulations/getReportStructureGames/tableGetReportStructureGames": 528,
	"./regulations/getReportStructureGames/tableGetReportStructureGames.js": 528,
	"./regulations/jackpotPayment/filterJackpotPaymentReports": 554,
	"./regulations/jackpotPayment/filterJackpotPaymentReports.js": 554,
	"./regulations/jackpotPayment/tableJackpotPaymentReports": 555,
	"./regulations/jackpotPayment/tableJackpotPaymentReports.js": 555,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports": 556,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports.js": 556,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports": 557,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports.js": 557,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino": 558,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino.js": 558,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino": 559,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino.js": 559,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet": 560,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet.js": 560,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet": 561,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet.js": 561,
	"./regulations/ownersIncome/filterOwnersIncomeReports": 683,
	"./regulations/ownersIncome/filterOwnersIncomeReports.js": 683,
	"./regulations/ownersIncome/tableOwnersIncomeReports": 684,
	"./regulations/ownersIncome/tableOwnersIncomeReports.js": 684,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports": 685,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports.js": 685,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports": 686,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports.js": 686,
	"./regulations/platformSpecific/filterPlatformSpecificReports": 838,
	"./regulations/platformSpecific/filterPlatformSpecificReports.js": 838,
	"./regulations/platformSpecific/tablePlatformSpecificReports": 839,
	"./regulations/platformSpecific/tablePlatformSpecificReports.js": 839,
	"./regulations/platformSpecific2/filterPlatformSpecificReports": 840,
	"./regulations/platformSpecific2/filterPlatformSpecificReports.js": 840,
	"./regulations/platformSpecific2/tablePlatformSpecificReports": 841,
	"./regulations/platformSpecific2/tablePlatformSpecificReports.js": 841,
	"./regulations/playerAccount/filterPlayerAccountReports": 842,
	"./regulations/playerAccount/filterPlayerAccountReports.js": 842,
	"./regulations/playerAccount/tablePlayerAccountReports": 843,
	"./regulations/playerAccount/tablePlayerAccountReports.js": 843,
	"./regulations/playerAccount2/filterPlayerAccountReports": 844,
	"./regulations/playerAccount2/filterPlayerAccountReports.js": 844,
	"./regulations/playerAccount2/tablePlayerAccountReports": 845,
	"./regulations/playerAccount2/tablePlayerAccountReports.js": 845,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports": 893,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports.js": 893,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports": 894,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports.js": 894,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports": 895,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports.js": 895,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports": 896,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports.js": 896,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports": 897,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports.js": 897,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports": 898,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports.js": 898,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports": 899,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports.js": 899,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports": 900,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports.js": 900,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports": 901,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports.js": 901,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports": 902,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports.js": 902,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports": 903,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports.js": 903,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports": 904,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports.js": 904,
	"./relationUserAggregator": 1804,
	"./relationUserAggregator.js": 1804,
	"./reportHash": 1805,
	"./reportHash.js": 1805,
	"./reportMarketing": 1806,
	"./reportMarketing.js": 1806,
	"./reports/affiliatesBetShop/filter": 210,
	"./reports/affiliatesBetShop/filter.js": 210,
	"./reports/affiliatesBetShop/table": 211,
	"./reports/affiliatesBetShop/table.js": 211,
	"./reports/assignmentQuota/filter": 295,
	"./reports/assignmentQuota/filter.js": 295,
	"./reports/assignmentQuota/table": 296,
	"./reports/assignmentQuota/table.js": 296,
	"./reports/assignmentQuotaMade/filter": 293,
	"./reports/assignmentQuotaMade/filter.js": 293,
	"./reports/assignmentQuotaMade/table": 294,
	"./reports/assignmentQuotaMade/table.js": 294,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers": 299,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 299,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers": 297,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers.js": 297,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers": 300,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers.js": 300,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers": 28,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 28,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers": 298,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers.js": 298,
	"./reports/balanceAdjustments/filter": 301,
	"./reports/balanceAdjustments/filter.js": 301,
	"./reports/balanceAdjustments/table": 302,
	"./reports/balanceAdjustments/table.js": 302,
	"./reports/balanceHistory/filter": 303,
	"./reports/balanceHistory/filter.js": 303,
	"./reports/balanceHistory/table": 304,
	"./reports/balanceHistory/table.js": 304,
	"./reports/balanceHistory2/filter": 1807,
	"./reports/balanceHistory2/filter.js": 1807,
	"./reports/balanceHistory2/filter2": 305,
	"./reports/balanceHistory2/filter2.js": 305,
	"./reports/balanceHistory2/table": 1808,
	"./reports/balanceHistory2/table.js": 1808,
	"./reports/balanceHistory2/table2": 306,
	"./reports/balanceHistory2/table2.js": 306,
	"./reports/balanceHistoryBetShop/filter": 309,
	"./reports/balanceHistoryBetShop/filter.js": 309,
	"./reports/balanceHistoryBetShop/table": 310,
	"./reports/balanceHistoryBetShop/table.js": 310,
	"./reports/balanceHistoryBetShop2/filter": 1809,
	"./reports/balanceHistoryBetShop2/filter.js": 1809,
	"./reports/balanceHistoryBetShop2/filter2": 311,
	"./reports/balanceHistoryBetShop2/filter2.js": 311,
	"./reports/balanceHistoryBetShop2/table": 1810,
	"./reports/balanceHistoryBetShop2/table.js": 1810,
	"./reports/balanceHistoryBetShop2/table2": 312,
	"./reports/balanceHistoryBetShop2/table2.js": 312,
	"./reports/balanceHistoryForAdminUser/filter": 307,
	"./reports/balanceHistoryForAdminUser/filter.js": 307,
	"./reports/balanceHistoryForAdminUser/table": 308,
	"./reports/balanceHistoryForAdminUser/table.js": 308,
	"./reports/balanceHistoryForAgent/filter": 313,
	"./reports/balanceHistoryForAgent/filter.js": 313,
	"./reports/balanceHistoryForAgent/table": 314,
	"./reports/balanceHistoryForAgent/table.js": 314,
	"./reports/balanceHistoryForBetShop/filter": 315,
	"./reports/balanceHistoryForBetShop/filter.js": 315,
	"./reports/balanceHistoryForBetShop/table": 316,
	"./reports/balanceHistoryForBetShop/table.js": 316,
	"./reports/balanceHistoryMachine/filter": 317,
	"./reports/balanceHistoryMachine/filter.js": 317,
	"./reports/balanceHistoryMachine/table": 318,
	"./reports/balanceHistoryMachine/table.js": 318,
	"./reports/balanceUsers/filter": 319,
	"./reports/balanceUsers/filter.js": 319,
	"./reports/balanceUsers/record": 135,
	"./reports/balanceUsers/record.js": 135,
	"./reports/balanceUsers/resume": 321,
	"./reports/balanceUsers/resume.js": 321,
	"./reports/balanceUsers/table": 320,
	"./reports/balanceUsers/table.js": 320,
	"./reports/betsReport/detailsReport": 1811,
	"./reports/betsReport/detailsReport.js": 1811,
	"./reports/betsReport/filterReport": 92,
	"./reports/betsReport/filterReport.js": 92,
	"./reports/betsReport/recordReport": 71,
	"./reports/betsReport/recordReport.js": 71,
	"./reports/betsReport/recordTableReport": 23,
	"./reports/betsReport/recordTableReport.js": 23,
	"./reports/betsReport/recordTableTransReport": 38,
	"./reports/betsReport/recordTableTransReport.js": 38,
	"./reports/betsReport/recordTransReport": 94,
	"./reports/betsReport/recordTransReport.js": 94,
	"./reports/betsReport/tableReport": 93,
	"./reports/betsReport/tableReport.js": 93,
	"./reports/betsReportBetShop/detailsReport": 1812,
	"./reports/betsReportBetShop/detailsReport.js": 1812,
	"./reports/betsReportBetShop/filterReport": 375,
	"./reports/betsReportBetShop/filterReport.js": 375,
	"./reports/betsReportBetShop/recordReport": 378,
	"./reports/betsReportBetShop/recordReport.js": 378,
	"./reports/betsReportBetShop/recordTableReport": 1813,
	"./reports/betsReportBetShop/recordTableReport.js": 1813,
	"./reports/betsReportBetShop/recordTableTransReport": 1814,
	"./reports/betsReportBetShop/recordTableTransReport.js": 1814,
	"./reports/betsReportBetShop/recordTransReport": 377,
	"./reports/betsReportBetShop/recordTransReport.js": 377,
	"./reports/betsReportBetShop/tableReport": 376,
	"./reports/betsReportBetShop/tableReport.js": 376,
	"./reports/bonusReport/detailsBonusReport": 139,
	"./reports/bonusReport/detailsBonusReport.js": 139,
	"./reports/bonusReport/filterBonusReport": 383,
	"./reports/bonusReport/filterBonusReport.js": 383,
	"./reports/bonusReport/recordBonusReport": 140,
	"./reports/bonusReport/recordBonusReport.js": 140,
	"./reports/bonusReport/recordTableBonusReport": 17,
	"./reports/bonusReport/recordTableBonusReport.js": 17,
	"./reports/bonusReport/tableBonusReport": 384,
	"./reports/bonusReport/tableBonusReport.js": 384,
	"./reports/bonusReport2/detailsBonusReport": 141,
	"./reports/bonusReport2/detailsBonusReport.js": 141,
	"./reports/bonusReport2/filterBonusReport": 385,
	"./reports/bonusReport2/filterBonusReport.js": 385,
	"./reports/bonusReport2/recordBonusReport": 142,
	"./reports/bonusReport2/recordBonusReport.js": 142,
	"./reports/bonusReport2/recordTableBonusReport": 1815,
	"./reports/bonusReport2/recordTableBonusReport.js": 1815,
	"./reports/bonusReport2/tableBonusReport": 386,
	"./reports/bonusReport2/tableBonusReport.js": 386,
	"./reports/bonusReports2/filter": 387,
	"./reports/bonusReports2/filter.js": 387,
	"./reports/bonusReports2/table": 388,
	"./reports/bonusReports2/table.js": 388,
	"./reports/casinoReport/detailsCasinoReport": 143,
	"./reports/casinoReport/detailsCasinoReport.js": 143,
	"./reports/casinoReport/filterCasinoReport": 419,
	"./reports/casinoReport/filterCasinoReport.js": 419,
	"./reports/casinoReport/recordCasinoReport": 144,
	"./reports/casinoReport/recordCasinoReport.js": 144,
	"./reports/casinoReport/recordTableCasinoReport": 9,
	"./reports/casinoReport/recordTableCasinoReport.js": 9,
	"./reports/casinoReport/tableCasinoReport": 420,
	"./reports/casinoReport/tableCasinoReport.js": 420,
	"./reports/casinoReport2/detailsCasinoReport": 145,
	"./reports/casinoReport2/detailsCasinoReport.js": 145,
	"./reports/casinoReport2/filterCasinoReport": 1816,
	"./reports/casinoReport2/filterCasinoReport.js": 1816,
	"./reports/casinoReport2/filterCasinoReport2": 421,
	"./reports/casinoReport2/filterCasinoReport2.js": 421,
	"./reports/casinoReport2/recordCasinoReport": 146,
	"./reports/casinoReport2/recordCasinoReport.js": 146,
	"./reports/casinoReport2/recordTableCasinoReport": 1817,
	"./reports/casinoReport2/recordTableCasinoReport.js": 1817,
	"./reports/casinoReport2/tableCasinoReport": 1818,
	"./reports/casinoReport2/tableCasinoReport.js": 1818,
	"./reports/casinoReport2/tableCasinoReport2": 422,
	"./reports/casinoReport2/tableCasinoReport2.js": 422,
	"./reports/comissions_report/filter": 429,
	"./reports/comissions_report/filter.js": 429,
	"./reports/comissions_report/table": 430,
	"./reports/comissions_report/table.js": 430,
	"./reports/comissions_report2/filter": 431,
	"./reports/comissions_report2/filter.js": 431,
	"./reports/comissions_report2/table": 432,
	"./reports/comissions_report2/table.js": 432,
	"./reports/commisionsPay/filter": 433,
	"./reports/commisionsPay/filter.js": 433,
	"./reports/commisionsPay/table": 434,
	"./reports/commisionsPay/table.js": 434,
	"./reports/coupons_report/details": 1819,
	"./reports/coupons_report/details.js": 1819,
	"./reports/coupons_report/filter": 448,
	"./reports/coupons_report/filter.js": 448,
	"./reports/coupons_report/record": 147,
	"./reports/coupons_report/record.js": 147,
	"./reports/coupons_report/recordReports": 1820,
	"./reports/coupons_report/recordReports.js": 1820,
	"./reports/coupons_report/table": 449,
	"./reports/coupons_report/table.js": 449,
	"./reports/customReport/filter": 454,
	"./reports/customReport/filter.js": 454,
	"./reports/customReport/table": 455,
	"./reports/customReport/table.js": 455,
	"./reports/depositReport2/filter": 500,
	"./reports/depositReport2/filter.js": 500,
	"./reports/depositReport2/table": 501,
	"./reports/depositReport2/table.js": 501,
	"./reports/depositReportFranchise/filterDepositReportFranchise": 506,
	"./reports/depositReportFranchise/filterDepositReportFranchise.js": 506,
	"./reports/depositReportFranchise/tableDepositReportFranchise": 507,
	"./reports/depositReportFranchise/tableDepositReportFranchise.js": 507,
	"./reports/deposit_report/detailsDepositReports": 1027,
	"./reports/deposit_report/detailsDepositReports.js": 1027,
	"./reports/deposit_report/filterDepositReports": 498,
	"./reports/deposit_report/filterDepositReports.js": 498,
	"./reports/deposit_report/recordDepositReports": 150,
	"./reports/deposit_report/recordDepositReports.js": 150,
	"./reports/deposit_report/recordTableDepositReports": 10,
	"./reports/deposit_report/recordTableDepositReports.js": 10,
	"./reports/deposit_report/tableDepositReports": 499,
	"./reports/deposit_report/tableDepositReports.js": 499,
	"./reports/deposit_report_3/detailsDepositReports": 1028,
	"./reports/deposit_report_3/detailsDepositReports.js": 1028,
	"./reports/deposit_report_3/filterDepositReports": 502,
	"./reports/deposit_report_3/filterDepositReports.js": 502,
	"./reports/deposit_report_3/recordDepositReports": 151,
	"./reports/deposit_report_3/recordDepositReports.js": 151,
	"./reports/deposit_report_3/recordTableDepositReports": 1821,
	"./reports/deposit_report_3/recordTableDepositReports.js": 1821,
	"./reports/deposit_report_3/tableDepositReports": 503,
	"./reports/deposit_report_3/tableDepositReports.js": 503,
	"./reports/deposit_report_betshop/detailsDepositReports": 1029,
	"./reports/deposit_report_betshop/detailsDepositReports.js": 1029,
	"./reports/deposit_report_betshop/filterDepositReports": 504,
	"./reports/deposit_report_betshop/filterDepositReports.js": 504,
	"./reports/deposit_report_betshop/recordDepositReports": 152,
	"./reports/deposit_report_betshop/recordDepositReports.js": 152,
	"./reports/deposit_report_betshop/recordTableDepositReports": 1822,
	"./reports/deposit_report_betshop/recordTableDepositReports.js": 1822,
	"./reports/deposit_report_betshop/tableDepositReports": 505,
	"./reports/deposit_report_betshop/tableDepositReports.js": 505,
	"./reports/emailsReport/detailsEmailsReport": 154,
	"./reports/emailsReport/detailsEmailsReport.js": 154,
	"./reports/emailsReport/filterEmailsReport": 515,
	"./reports/emailsReport/filterEmailsReport.js": 515,
	"./reports/emailsReport/recordEmailsReport": 155,
	"./reports/emailsReport/recordEmailsReport.js": 155,
	"./reports/emailsReport/recordTableEmailsReport": 1823,
	"./reports/emailsReport/recordTableEmailsReport.js": 1823,
	"./reports/emailsReport/tableEmailsReport": 516,
	"./reports/emailsReport/tableEmailsReport.js": 516,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido": 911,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 911,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido": 912,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido.js": 912,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido": 913,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido.js": 913,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido": 30,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 30,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido": 914,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido.js": 914,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido": 915,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido.js": 915,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido": 1824,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido.js": 1824,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2": 916,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2.js": 916,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido": 917,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido.js": 917,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido": 1825,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido.js": 1825,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido": 1826,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido.js": 1826,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2": 918,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2.js": 918,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido": 919,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido.js": 919,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido": 920,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido.js": 920,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido": 921,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido.js": 921,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido": 1827,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido.js": 1827,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido": 922,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido.js": 922,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow": 531,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow.js": 531,
	"./reports/historicalCashFlow/filterHistoricalCashFlow": 529,
	"./reports/historicalCashFlow/filterHistoricalCashFlow.js": 529,
	"./reports/historicalCashFlow/recordHistoricalCashFlow": 532,
	"./reports/historicalCashFlow/recordHistoricalCashFlow.js": 532,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow": 533,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 533,
	"./reports/historicalCashFlow/tableHistoricalCashFlow": 530,
	"./reports/historicalCashFlow/tableHistoricalCashFlow.js": 530,
	"./reports/historyMovement/filter": 534,
	"./reports/historyMovement/filter.js": 534,
	"./reports/historyMovement/table": 535,
	"./reports/historyMovement/table.js": 535,
	"./reports/historyMovementBetShop/filter": 536,
	"./reports/historyMovementBetShop/filter.js": 536,
	"./reports/historyMovementBetShop/table": 537,
	"./reports/historyMovementBetShop/table.js": 537,
	"./reports/historyPoints/filter": 538,
	"./reports/historyPoints/filter.js": 538,
	"./reports/historyPoints/table": 539,
	"./reports/historyPoints/table.js": 539,
	"./reports/informeCasino/detailsInformeCasino": 542,
	"./reports/informeCasino/detailsInformeCasino.js": 542,
	"./reports/informeCasino/filterInformeCasino": 540,
	"./reports/informeCasino/filterInformeCasino.js": 540,
	"./reports/informeCasino/recordInformeCasino": 543,
	"./reports/informeCasino/recordInformeCasino.js": 543,
	"./reports/informeCasino/recordTableInformeCasino": 1828,
	"./reports/informeCasino/recordTableInformeCasino.js": 1828,
	"./reports/informeCasino/tableInformeCasino": 541,
	"./reports/informeCasino/tableInformeCasino.js": 541,
	"./reports/informeConsolidatedIncome/filterInformeConsolidatedIncome": 438,
	"./reports/informeConsolidatedIncome/filterInformeConsolidatedIncome.js": 438,
	"./reports/informeConsolidatedIncome/tableInformeConsolidatedIncome": 437,
	"./reports/informeConsolidatedIncome/tableInformeConsolidatedIncome.js": 437,
	"./reports/informeGerencial/detailsInformeGerencial": 1829,
	"./reports/informeGerencial/detailsInformeGerencial.js": 1829,
	"./reports/informeGerencial/filterInformeGerencial": 544,
	"./reports/informeGerencial/filterInformeGerencial.js": 544,
	"./reports/informeGerencial/recordInformeGerencial": 1830,
	"./reports/informeGerencial/recordInformeGerencial.js": 1830,
	"./reports/informeGerencial/recordTableInformeGerencial": 29,
	"./reports/informeGerencial/recordTableInformeGerencial.js": 29,
	"./reports/informeGerencial/tableInformeGerencial": 545,
	"./reports/informeGerencial/tableInformeGerencial.js": 545,
	"./reports/informeGerencial2/detailsInformeGerencial": 1831,
	"./reports/informeGerencial2/detailsInformeGerencial.js": 1831,
	"./reports/informeGerencial2/filterInformeGerencial": 1832,
	"./reports/informeGerencial2/filterInformeGerencial.js": 1832,
	"./reports/informeGerencial2/filterInformeGerencial2": 546,
	"./reports/informeGerencial2/filterInformeGerencial2.js": 546,
	"./reports/informeGerencial2/recordInformeGerencial": 1833,
	"./reports/informeGerencial2/recordInformeGerencial.js": 1833,
	"./reports/informeGerencial2/recordTableInformeGerencial": 1834,
	"./reports/informeGerencial2/recordTableInformeGerencial.js": 1834,
	"./reports/informeGerencial2/tableInformeGerencial": 1835,
	"./reports/informeGerencial2/tableInformeGerencial.js": 1835,
	"./reports/informeGerencial2/tableInformeGerencial2": 547,
	"./reports/informeGerencial2/tableInformeGerencial2.js": 547,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial": 1836,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial.js": 1836,
	"./reports/informeGerencialAgentes2/filterInformeGerencial": 1837,
	"./reports/informeGerencialAgentes2/filterInformeGerencial.js": 1837,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2": 548,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2.js": 548,
	"./reports/informeGerencialAgentes2/recordInformeGerencial": 1838,
	"./reports/informeGerencialAgentes2/recordInformeGerencial.js": 1838,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial": 1839,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial.js": 1839,
	"./reports/informeGerencialAgentes2/tableInformeGerencial": 1840,
	"./reports/informeGerencialAgentes2/tableInformeGerencial.js": 1840,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2": 549,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2.js": 549,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial": 1841,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial.js": 1841,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial": 1842,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial.js": 1842,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2": 550,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2.js": 550,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial": 1843,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial.js": 1843,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial": 1844,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial.js": 1844,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial": 1845,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial.js": 1845,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2": 551,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2.js": 551,
	"./reports/jackpotInternationalReport/filter": 552,
	"./reports/jackpotInternationalReport/filter.js": 552,
	"./reports/jackpotInternationalReport/table": 553,
	"./reports/jackpotInternationalReport/table.js": 553,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports": 562,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports.js": 562,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports": 1846,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports.js": 1846,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports": 1847,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports.js": 1847,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports": 563,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports.js": 563,
	"./reports/landingReport/detailsLandingReport": 566,
	"./reports/landingReport/detailsLandingReport.js": 566,
	"./reports/landingReport/filterLandingReport": 564,
	"./reports/landingReport/filterLandingReport.js": 564,
	"./reports/landingReport/recordLandingReport": 567,
	"./reports/landingReport/recordLandingReport.js": 567,
	"./reports/landingReport/recordTableLandingReport": 1848,
	"./reports/landingReport/recordTableLandingReport.js": 1848,
	"./reports/landingReport/tableLandingReport": 565,
	"./reports/landingReport/tableLandingReport.js": 565,
	"./reports/landingReport2/detailsLandingReport": 158,
	"./reports/landingReport2/detailsLandingReport.js": 158,
	"./reports/landingReport2/filterLandingReport": 568,
	"./reports/landingReport2/filterLandingReport.js": 568,
	"./reports/landingReport2/recordLandingReport": 159,
	"./reports/landingReport2/recordLandingReport.js": 159,
	"./reports/landingReport2/recordTableLandingReport": 1849,
	"./reports/landingReport2/recordTableLandingReport.js": 1849,
	"./reports/landingReport2/tableLandingReport": 569,
	"./reports/landingReport2/tableLandingReport.js": 569,
	"./reports/limitationsReport/filterDepositReports": 586,
	"./reports/limitationsReport/filterDepositReports.js": 586,
	"./reports/limitationsReport/tableDepositReports": 587,
	"./reports/limitationsReport/tableDepositReports.js": 587,
	"./reports/logsUser/filter": 590,
	"./reports/logsUser/filter.js": 590,
	"./reports/logsUser/table": 591,
	"./reports/logsUser/table.js": 591,
	"./reports/loteryReport/detailsLoteryReport": 160,
	"./reports/loteryReport/detailsLoteryReport.js": 160,
	"./reports/loteryReport/filterLoteryReport": 592,
	"./reports/loteryReport/filterLoteryReport.js": 592,
	"./reports/loteryReport/recordLoteryReport": 161,
	"./reports/loteryReport/recordLoteryReport.js": 161,
	"./reports/loteryReport/recordTableLoteryReport": 1850,
	"./reports/loteryReport/recordTableLoteryReport.js": 1850,
	"./reports/loteryReport/tableLoteryReport": 47,
	"./reports/loteryReport/tableLoteryReport.js": 47,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 593,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 593,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 594,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 594,
	"./reports/my_comissions_report/filter": 677,
	"./reports/my_comissions_report/filter.js": 677,
	"./reports/my_comissions_report/table": 678,
	"./reports/my_comissions_report/table.js": 678,
	"./reports/notesUser/filter": 679,
	"./reports/notesUser/filter.js": 679,
	"./reports/notesUser/table": 680,
	"./reports/notesUser/table.js": 680,
	"./reports/operatorResponsibility/filter": 681,
	"./reports/operatorResponsibility/filter.js": 681,
	"./reports/operatorResponsibility/table": 682,
	"./reports/operatorResponsibility/table.js": 682,
	"./reports/partners-categories/filter": 819,
	"./reports/partners-categories/filter.js": 819,
	"./reports/partners-categories/table": 820,
	"./reports/partners-categories/table.js": 820,
	"./reports/playersReport/detailsPlayersReport": 848,
	"./reports/playersReport/detailsPlayersReport.js": 848,
	"./reports/playersReport/filterPlayersReport": 846,
	"./reports/playersReport/filterPlayersReport.js": 846,
	"./reports/playersReport/recordPlayersReport": 849,
	"./reports/playersReport/recordPlayersReport.js": 849,
	"./reports/playersReport/recordTablePlayersReport": 850,
	"./reports/playersReport/recordTablePlayersReport.js": 850,
	"./reports/playersReport/tablePlayersReport": 847,
	"./reports/playersReport/tablePlayersReport.js": 847,
	"./reports/pointSettings/filter": 851,
	"./reports/pointSettings/filter.js": 851,
	"./reports/pointSettings/table": 852,
	"./reports/pointSettings/table.js": 852,
	"./reports/pointsUsers/filter": 853,
	"./reports/pointsUsers/filter.js": 853,
	"./reports/pointsUsers/table": 854,
	"./reports/pointsUsers/table.js": 854,
	"./reports/pokerReport/filterCasinoReport": 855,
	"./reports/pokerReport/filterCasinoReport.js": 855,
	"./reports/pokerReport/tableCasinoReport": 856,
	"./reports/pokerReport/tableCasinoReport.js": 856,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1851,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1851,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar": 687,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 687,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1852,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1852,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 923,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 923,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar": 688,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 688,
	"./reports/prizesLoyalty/filter": 857,
	"./reports/prizesLoyalty/filter.js": 857,
	"./reports/prizesLoyalty/table": 858,
	"./reports/prizesLoyalty/table.js": 858,
	"./reports/promotionalCasinoCampaings/filter": 874,
	"./reports/promotionalCasinoCampaings/filter.js": 874,
	"./reports/promotionalCasinoCampaings/table": 875,
	"./reports/promotionalCasinoCampaings/table.js": 875,
	"./reports/promotionalCodes/filter": 876,
	"./reports/promotionalCodes/filter.js": 876,
	"./reports/promotionalCodes/table": 877,
	"./reports/promotionalCodes/table.js": 877,
	"./reports/promotionalSpoortbookCampaings/filter": 878,
	"./reports/promotionalSpoortbookCampaings/filter.js": 878,
	"./reports/promotionalSpoortbookCampaings/table": 879,
	"./reports/promotionalSpoortbookCampaings/table.js": 879,
	"./reports/quotaRetraction/filter": 882,
	"./reports/quotaRetraction/filter.js": 882,
	"./reports/quotaRetraction/table": 883,
	"./reports/quotaRetraction/table.js": 883,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports": 884,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports.js": 884,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports": 1853,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports.js": 1853,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports": 1854,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports.js": 1854,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports": 885,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports.js": 885,
	"./reports/referralsReport/filterReferralsReports": 886,
	"./reports/referralsReport/filterReferralsReports.js": 886,
	"./reports/referralsReport/recordReferralsReports": 1855,
	"./reports/referralsReport/recordReferralsReports.js": 1855,
	"./reports/referralsReport/recordTableReferralsReports": 1856,
	"./reports/referralsReport/recordTableReferralsReports.js": 1856,
	"./reports/referralsReport/tableReferralsReports": 887,
	"./reports/referralsReport/tableReferralsReports.js": 887,
	"./reports/registeredDocuments/filter": 888,
	"./reports/registeredDocuments/filter.js": 888,
	"./reports/registeredDocuments/record": 164,
	"./reports/registeredDocuments/record.js": 164,
	"./reports/registeredDocuments/recordTable": 890,
	"./reports/registeredDocuments/recordTable.js": 890,
	"./reports/registeredDocuments/table": 889,
	"./reports/registeredDocuments/table.js": 889,
	"./reports/relationUserAggregator/filter": 905,
	"./reports/relationUserAggregator/filter.js": 905,
	"./reports/relationUserAggregator/table": 906,
	"./reports/relationUserAggregator/table.js": 906,
	"./reports/reportHash/filter": 907,
	"./reports/reportHash/filter.js": 907,
	"./reports/reportHash/table": 908,
	"./reports/reportHash/table.js": 908,
	"./reports/reportMarketing/filter": 909,
	"./reports/reportMarketing/filter.js": 909,
	"./reports/reportMarketing/table": 910,
	"./reports/reportMarketing/table.js": 910,
	"./reports/rouletteReport/filter": 924,
	"./reports/rouletteReport/filter.js": 924,
	"./reports/rouletteReport/table": 925,
	"./reports/rouletteReport/table.js": 925,
	"./reports/sessionsReport/detailsSessionsReport": 926,
	"./reports/sessionsReport/detailsSessionsReport.js": 926,
	"./reports/sessionsReport/filterSessionsReport": 927,
	"./reports/sessionsReport/filterSessionsReport.js": 927,
	"./reports/sessionsReport/recordSessionsReport": 1043,
	"./reports/sessionsReport/recordSessionsReport.js": 1043,
	"./reports/sessionsReport/recordTableSessionsReport": 1044,
	"./reports/sessionsReport/recordTableSessionsReport.js": 1044,
	"./reports/sessionsReport/tableSessionsReport": 928,
	"./reports/sessionsReport/tableSessionsReport.js": 928,
	"./reports/sessionsReport2/filter": 929,
	"./reports/sessionsReport2/filter.js": 929,
	"./reports/sessionsReport2/table": 930,
	"./reports/sessionsReport2/table.js": 930,
	"./reports/sportsPoolReport/filterReport": 931,
	"./reports/sportsPoolReport/filterReport.js": 931,
	"./reports/sportsPoolReport/tableReport": 932,
	"./reports/sportsPoolReport/tableReport.js": 932,
	"./reports/sportsTransactions/filter": 933,
	"./reports/sportsTransactions/filter.js": 933,
	"./reports/sportsTransactions/table": 934,
	"./reports/sportsTransactions/table.js": 934,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido": 935,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido.js": 935,
	"./reports/summaryBetsReport/filterFlujoCajaResumido": 936,
	"./reports/summaryBetsReport/filterFlujoCajaResumido.js": 936,
	"./reports/summaryBetsReport/recordFlujoCajaResumido": 937,
	"./reports/summaryBetsReport/recordFlujoCajaResumido.js": 937,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido": 1857,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido.js": 1857,
	"./reports/summaryBetsReport/tableFlujoCajaResumido": 938,
	"./reports/summaryBetsReport/tableFlujoCajaResumido.js": 938,
	"./reports/taxPaymentsReport/filter": 939,
	"./reports/taxPaymentsReport/filter.js": 939,
	"./reports/taxPaymentsReport/table": 940,
	"./reports/taxPaymentsReport/table.js": 940,
	"./reports/taxableEarnings/filter": 941,
	"./reports/taxableEarnings/filter.js": 941,
	"./reports/taxableEarnings/table": 942,
	"./reports/taxableEarnings/table.js": 942,
	"./reports/transactionReport/filter": 943,
	"./reports/transactionReport/filter.js": 943,
	"./reports/transactionReport/table": 944,
	"./reports/transactionReport/table.js": 944,
	"./reports/transfersReport/filter": 945,
	"./reports/transfersReport/filter.js": 945,
	"./reports/transfersReport/table": 946,
	"./reports/transfersReport/table.js": 946,
	"./reports/userAffiliatesAgent/filter": 947,
	"./reports/userAffiliatesAgent/filter.js": 947,
	"./reports/userAffiliatesAgent/table": 948,
	"./reports/userAffiliatesAgent/table.js": 948,
	"./reports/userAffiliatesBetShop/filter": 949,
	"./reports/userAffiliatesBetShop/filter.js": 949,
	"./reports/userAffiliatesBetShop/table": 950,
	"./reports/userAffiliatesBetShop/table.js": 950,
	"./reports/usuarioOnlineResumido/filter": 951,
	"./reports/usuarioOnlineResumido/filter.js": 951,
	"./reports/usuarioOnlineResumido/table": 952,
	"./reports/usuarioOnlineResumido/table.js": 952,
	"./reports/withdrawalReport2/filter": 953,
	"./reports/withdrawalReport2/filter.js": 953,
	"./reports/withdrawalReport2/table": 954,
	"./reports/withdrawalReport2/table.js": 954,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests": 955,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 955,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest": 956,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 956,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1858,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1858,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest": 957,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 957,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest": 958,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 958,
	"./reports/withdrawalRequestsComissions/filter": 959,
	"./reports/withdrawalRequestsComissions/filter.js": 959,
	"./reports/withdrawalRequestsComissions/table": 960,
	"./reports/withdrawalRequestsComissions/table.js": 960,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop": 165,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop.js": 165,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop": 961,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop.js": 961,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop": 125,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop.js": 125,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop": 166,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop.js": 166,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop": 962,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop.js": 962,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop": 167,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop.js": 167,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop": 963,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop.js": 963,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop": 1859,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop.js": 1859,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop": 168,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop.js": 168,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop": 964,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop.js": 964,
	"./reprintCheck": 1860,
	"./reprintCheck.js": 1860,
	"./requests/registration-requests/filter": 965,
	"./requests/registration-requests/filter.js": 965,
	"./requests/registration-requests/generateRequests": 966,
	"./requests/registration-requests/generateRequests.js": 966,
	"./requests/registration-requests/recordTableResponts": 967,
	"./requests/registration-requests/recordTableResponts.js": 967,
	"./requests/registration-requests/table": 969,
	"./requests/registration-requests/table.js": 969,
	"./requests/registration-requests/tableResponts": 968,
	"./requests/registration-requests/tableResponts.js": 968,
	"./requests/registrationRequests": 1861,
	"./requests/registrationRequests.js": 1861,
	"./resources-locale_es.json": 1963,
	"./restrictUser": 1862,
	"./restrictUser.js": 1862,
	"./reversionReload": 1863,
	"./reversionReload.js": 1863,
	"./rouletteReport": 1864,
	"./rouletteReport.js": 1864,
	"./security/adminuser/addAdminUser": 1865,
	"./security/adminuser/addAdminUser.js": 1865,
	"./security/adminuser/configuration/changePassword": 1866,
	"./security/adminuser/configuration/changePassword.js": 1866,
	"./security/adminuser/configuration/changePassword/changePasswordView": 970,
	"./security/adminuser/configuration/changePassword/changePasswordView.js": 970,
	"./security/adminuser/configuration/generateToken": 1867,
	"./security/adminuser/configuration/generateToken.js": 1867,
	"./security/adminuser/configuration/generateToken/filter": 971,
	"./security/adminuser/configuration/generateToken/filter.js": 971,
	"./security/adminuser/configuration/generateToken/table": 972,
	"./security/adminuser/configuration/generateToken/table.js": 972,
	"./security/adminuser/configuration/qrgoogle": 1868,
	"./security/adminuser/configuration/qrgoogle.js": 1868,
	"./security/adminuser/configuration/securityChanges": 1869,
	"./security/adminuser/configuration/securityChanges.js": 1869,
	"./security/adminuser/configuration/securityChanges/filter": 171,
	"./security/adminuser/configuration/securityChanges/filter.js": 171,
	"./security/adminuser/configuration/securityChanges/table": 129,
	"./security/adminuser/configuration/securityChanges/table.js": 129,
	"./security/adminuser/configurationAdminUser": 1870,
	"./security/adminuser/configurationAdminUser.js": 1870,
	"./security/adminuser/detailsAdminUser": 1871,
	"./security/adminuser/detailsAdminUser.js": 1871,
	"./security/adminuser/filterAdminUser": 208,
	"./security/adminuser/filterAdminUser.js": 208,
	"./security/adminuser/informationAdminUser": 1872,
	"./security/adminuser/informationAdminUser.js": 1872,
	"./security/adminuser/recordAdminUser": 1873,
	"./security/adminuser/recordAdminUser.js": 1873,
	"./security/adminuser/recordTableAdminUser": 973,
	"./security/adminuser/recordTableAdminUser.js": 973,
	"./security/adminuser/reports/logsUser": 1874,
	"./security/adminuser/reports/logsUser.js": 1874,
	"./security/adminuser/reports/logsUser/filter": 974,
	"./security/adminuser/reports/logsUser/filter.js": 974,
	"./security/adminuser/reports/logsUser/table": 975,
	"./security/adminuser/reports/logsUser/table.js": 975,
	"./security/adminuser/reportsAdminUser": 1875,
	"./security/adminuser/reportsAdminUser.js": 1875,
	"./security/adminuser/tableAdminUser": 209,
	"./security/adminuser/tableAdminUser.js": 209,
	"./security/approvalLogs/filter": 287,
	"./security/approvalLogs/filter.js": 287,
	"./security/approvalLogs/table": 288,
	"./security/approvalLogs/table.js": 288,
	"./security/approvalLogs2/filter": 289,
	"./security/approvalLogs2/filter.js": 289,
	"./security/approvalLogs2/table": 290,
	"./security/approvalLogs2/table.js": 290,
	"./security/approvalLogsBetShop/filter": 291,
	"./security/approvalLogsBetShop/filter.js": 291,
	"./security/approvalLogsBetShop/table": 292,
	"./security/approvalLogsBetShop/table.js": 292,
	"./security/contingencia/detailsContingencia": 1876,
	"./security/contingencia/detailsContingencia.js": 1876,
	"./security/contingencia/filterContingencia": 443,
	"./security/contingencia/filterContingencia.js": 443,
	"./security/contingencia/recordContingencia": 1877,
	"./security/contingencia/recordContingencia.js": 1877,
	"./security/contingencia/recordTableContingencia": 976,
	"./security/contingencia/recordTableContingencia.js": 976,
	"./security/contingencia/tableContingencia": 444,
	"./security/contingencia/tableContingencia.js": 444,
	"./security/menu/filter": 667,
	"./security/menu/filter.js": 667,
	"./security/menu/table": 668,
	"./security/menu/table.js": 668,
	"./security/perfil/detailsPerfil": 871,
	"./security/perfil/detailsPerfil.js": 871,
	"./security/perfil/filterPerfil": 869,
	"./security/perfil/filterPerfil.js": 869,
	"./security/perfil/recordPerfil": 872,
	"./security/perfil/recordPerfil.js": 872,
	"./security/perfil/recordTablePerfil": 873,
	"./security/perfil/recordTablePerfil.js": 873,
	"./security/perfil/tablePerfil": 870,
	"./security/perfil/tablePerfil.js": 870,
	"./security/perfilopciones/detailsPerfilOpciones": 123,
	"./security/perfilopciones/detailsPerfilOpciones.js": 123,
	"./security/perfilopciones/filterPerfilOpciones": 85,
	"./security/perfilopciones/filterPerfilOpciones.js": 85,
	"./security/perfilopciones/permissionsTree": 163,
	"./security/perfilopciones/permissionsTree.js": 163,
	"./security/perfilopciones/recordPerfilOpciones": 124,
	"./security/perfilopciones/recordPerfilOpciones.js": 124,
	"./security/perfilopciones/recordTablePerfilOpciones": 65,
	"./security/perfilopciones/recordTablePerfilOpciones.js": 65,
	"./security/perfilopciones/tablePerfilOpciones": 64,
	"./security/perfilopciones/tablePerfilOpciones.js": 64,
	"./security/perfilopciones2/detailsPerfilOpciones": 1878,
	"./security/perfilopciones2/detailsPerfilOpciones.js": 1878,
	"./security/perfilopciones2/filterPerfilOpciones": 1879,
	"./security/perfilopciones2/filterPerfilOpciones.js": 1879,
	"./security/perfilopciones2/recordPerfilOpciones": 1880,
	"./security/perfilopciones2/recordPerfilOpciones.js": 1880,
	"./security/perfilopciones2/recordTablePerfilOpciones": 1881,
	"./security/perfilopciones2/recordTablePerfilOpciones.js": 1881,
	"./security/perfilopciones2/tablePerfilOpciones": 1882,
	"./security/perfilopciones2/tablePerfilOpciones.js": 1882,
	"./security/perfilopcionesOld/detailsPerfilOpciones": 1883,
	"./security/perfilopcionesOld/detailsPerfilOpciones.js": 1883,
	"./security/perfilopcionesOld/filterPerfilOpciones": 1884,
	"./security/perfilopcionesOld/filterPerfilOpciones.js": 1884,
	"./security/perfilopcionesOld/recordPerfilOpciones": 1885,
	"./security/perfilopcionesOld/recordPerfilOpciones.js": 1885,
	"./security/perfilopcionesOld/recordTablePerfilOpciones": 1886,
	"./security/perfilopcionesOld/recordTablePerfilOpciones.js": 1886,
	"./security/perfilopcionesOld/tablePerfilOpciones": 1887,
	"./security/perfilopcionesOld/tablePerfilOpciones.js": 1887,
	"./security/submenu/detailsSubMenu": 977,
	"./security/submenu/detailsSubMenu.js": 977,
	"./security/submenu/filterSubMenu": 978,
	"./security/submenu/filterSubMenu.js": 978,
	"./security/submenu/recordSubMenu": 979,
	"./security/submenu/recordSubMenu.js": 979,
	"./security/submenu/recordTableSubMenu": 980,
	"./security/submenu/recordTableSubMenu.js": 980,
	"./security/submenu/tableSubMenu": 981,
	"./security/submenu/tableSubMenu.js": 981,
	"./security/totalContingencies/table": 982,
	"./security/totalContingencies/table.js": 982,
	"./security/userSitebuilder/filter": 983,
	"./security/userSitebuilder/filter.js": 983,
	"./security/userSitebuilder/information": 1888,
	"./security/userSitebuilder/information.js": 1888,
	"./security/userSitebuilder/table": 984,
	"./security/userSitebuilder/table.js": 984,
	"./security/userVerification2/filter": 985,
	"./security/userVerification2/filter.js": 985,
	"./security/userVerification2/information": 1889,
	"./security/userVerification2/information.js": 1889,
	"./security/userVerification2/table": 986,
	"./security/userVerification2/table.js": 986,
	"./security/usuarioperfil/detailsUsuarioPerfil": 1890,
	"./security/usuarioperfil/detailsUsuarioPerfil.js": 1890,
	"./security/usuarioperfil/filterUsuarioPerfil": 987,
	"./security/usuarioperfil/filterUsuarioPerfil.js": 987,
	"./security/usuarioperfil/recordTableUsuarioPerfil": 988,
	"./security/usuarioperfil/recordTableUsuarioPerfil.js": 988,
	"./security/usuarioperfil/recordUsuarioPerfil": 1891,
	"./security/usuarioperfil/recordUsuarioPerfil.js": 1891,
	"./security/usuarioperfil/tableUsuarioPerfil": 989,
	"./security/usuarioperfil/tableUsuarioPerfil.js": 989,
	"./security/usuariosbloqueados/add": 1892,
	"./security/usuariosbloqueados/add.js": 1892,
	"./security/usuariosbloqueados/filter": 990,
	"./security/usuariosbloqueados/filter.js": 990,
	"./security/usuariosbloqueados/table": 991,
	"./security/usuariosbloqueados/table.js": 991,
	"./security/wallets/filter": 992,
	"./security/wallets/filter.js": 992,
	"./security/wallets/table": 993,
	"./security/wallets/table.js": 993,
	"./sessionsReport": 1893,
	"./sessionsReport.js": 1893,
	"./sessionsReport2": 1894,
	"./sessionsReport2.js": 1894,
	"./settings": 1895,
	"./settings.js": 1895,
	"./significantEventsAndAlterations": 1896,
	"./significantEventsAndAlterations.js": 1896,
	"./significantEventsAndAlterations2": 1897,
	"./significantEventsAndAlterations2.js": 1897,
	"./sportsPoolReport": 1898,
	"./sportsPoolReport.js": 1898,
	"./sportsTransactions": 1899,
	"./sportsTransactions.js": 1899,
	"./subMenu": 1900,
	"./subMenu.js": 1900,
	"./subProviders": 1901,
	"./subProviders.js": 1901,
	"./summaryBetsReport": 1902,
	"./summaryBetsReport.js": 1902,
	"./summaryCashFlow": 1903,
	"./summaryCashFlow.js": 1903,
	"./summaryCashFlow2": 1904,
	"./summaryCashFlow2.js": 1904,
	"./summaryCashFlowMachine": 1905,
	"./summaryCashFlowMachine.js": 1905,
	"./tags": 1906,
	"./tags.js": 1906,
	"./taxPaymentsReport": 1907,
	"./taxPaymentsReport.js": 1907,
	"./taxableEarnings": 1908,
	"./taxableEarnings.js": 1908,
	"./teacher/concessionaire/filterConcessionaire": 519,
	"./teacher/concessionaire/filterConcessionaire.js": 519,
	"./teacher/concessionaire/tableConcessionaire": 520,
	"./teacher/concessionaire/tableConcessionaire.js": 520,
	"./teacher/qualifying/filterQualifying": 880,
	"./teacher/qualifying/filterQualifying.js": 880,
	"./teacher/qualifying/tableQualifying": 881,
	"./teacher/qualifying/tableQualifying.js": 881,
	"./teacher/registered-documents/filterRegisteredDocuments": 891,
	"./teacher/registered-documents/filterRegisteredDocuments.js": 891,
	"./teacher/registered-documents/tableRegisteredDocuments": 892,
	"./teacher/registered-documents/tableRegisteredDocuments.js": 892,
	"./termsAndConditions": 1909,
	"./termsAndConditions.js": 1909,
	"./toolbar": 12,
	"./toolbar.js": 12,
	"./tools/countries/filter": 445,
	"./tools/countries/filter.js": 445,
	"./tools/countries/table": 446,
	"./tools/countries/table.js": 446,
	"./tools/currencyManagement/currencyFilters": 172,
	"./tools/currencyManagement/currencyFilters.js": 172,
	"./tools/currencyManagement/currencyTable": 173,
	"./tools/currencyManagement/currencyTable.js": 173,
	"./tools/translationManager": 1910,
	"./tools/translationManager.js": 1910,
	"./tools/translationManager/filter": 994,
	"./tools/translationManager/filter.js": 994,
	"./tools/translationManager/table": 995,
	"./tools/translationManager/table.js": 995,
	"./tools/uploadImage": 1911,
	"./tools/uploadImage.js": 1911,
	"./top": 1912,
	"./top.js": 1912,
	"./totalContingencies": 1913,
	"./totalContingencies.js": 1913,
	"./transactionReport": 1914,
	"./transactionReport.js": 1914,
	"./transactions": 1915,
	"./transactions.js": 1915,
	"./transactionsByPlayer": 1916,
	"./transactionsByPlayer.js": 1916,
	"./transactionsByPlayerDeposit": 1917,
	"./transactionsByPlayerDeposit.js": 1917,
	"./transactionsByPlayerFirstLevel": 1918,
	"./transactionsByPlayerFirstLevel.js": 1918,
	"./transactionsByPlayerSecondLevel": 1919,
	"./transactionsByPlayerSecondLevel.js": 1919,
	"./trasnfersReport": 1920,
	"./trasnfersReport.js": 1920,
	"./tutorials": 1921,
	"./tutorials.js": 1921,
	"./userAffiliatesAgent": 1922,
	"./userAffiliatesAgent.js": 1922,
	"./userAffiliatesBetShop": 1923,
	"./userAffiliatesBetShop.js": 1923,
	"./userManagement": 1924,
	"./userManagement.js": 1924,
	"./userManagement/userManagement/detailsUserManagement": 998,
	"./userManagement/userManagement/detailsUserManagement.js": 998,
	"./userManagement/userManagement/filterUserManagement": 996,
	"./userManagement/userManagement/filterUserManagement.js": 996,
	"./userManagement/userManagement/recordTableUserManagement": 1000,
	"./userManagement/userManagement/recordTableUserManagement.js": 1000,
	"./userManagement/userManagement/recordUserManagement": 999,
	"./userManagement/userManagement/recordUserManagement.js": 999,
	"./userManagement/userManagement/tableUserManagement": 997,
	"./userManagement/userManagement/tableUserManagement.js": 997,
	"./userProfile": 1925,
	"./userProfile.js": 1925,
	"./usersSitebuilder": 1926,
	"./usersSitebuilder.js": 1926,
	"./usersVerification": 1927,
	"./usersVerification.js": 1927,
	"./usersVerification/information": 1001,
	"./usersVerification/information.js": 1001,
	"./usersVerification2": 1928,
	"./usersVerification2.js": 1928,
	"./usersVerificationManagement": 1929,
	"./usersVerificationManagement.js": 1929,
	"./usuarioOnlineResumido": 1930,
	"./usuarioOnlineResumido.js": 1930,
	"./usuariosbloqueados": 1931,
	"./usuariosbloqueados.js": 1931,
	"./verifyAccount": 1932,
	"./verifyAccount.js": 1932,
	"./verifyAccountAgent": 1933,
	"./verifyAccountAgent.js": 1933,
	"./verifyAccountJumio": 1934,
	"./verifyAccountJumio.js": 1934,
	"./wallets": 1935,
	"./wallets.js": 1935,
	"./watchListReport": 1936,
	"./watchListReport.js": 1936,
	"./watchListReport/filterReport": 1002,
	"./watchListReport/filterReport.js": 1002,
	"./watchListReport/tableReport": 1003,
	"./watchListReport/tableReport.js": 1003,
	"./widgets": 1937,
	"./widgets.js": 1937,
	"./withdrawal": 1938,
	"./withdrawal.js": 1938,
	"./withdrawalReport2": 1939,
	"./withdrawalReport2.js": 1939,
	"./withdrawalRequests": 1940,
	"./withdrawalRequests.js": 1940,
	"./withdrawalRequestsBetShop": 1941,
	"./withdrawalRequestsBetShop.js": 1941,
	"./withdrawalRequestsComissions": 1942,
	"./withdrawalRequestsComissions.js": 1942,
	"./withdrawalRequestsForBetShop": 1943,
	"./withdrawalRequestsForBetShop.js": 1943,
	"./withdrawalRequestsForBetShop2": 1944,
	"./withdrawalRequestsForBetShop2.js": 1944,
	"./withdrawalRequestsRetail": 1945,
	"./withdrawalRequestsRetail.js": 1945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1955;